<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{renderTitle(arry_aac.I)}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="4">
                                            <label class="col-form-label">{{this.getLanguage["MT"]["BN"]}}<span class="required" /> :</label>
                                            <customtreeselect :multiple="true"
                                                              :limit="1"
                                                              :clearable="false"
                                                              valueConsistsOf="LEAF_PRIORITY"
                                                              :options="dd_agentgroup"
                                                              :defaultExpandLevel="Infinity"
                                                              :disable-branch-nodes="false"
                                                              :disabled="arry_aac.I > 0"
                                                              v-model="searchAgent"
                                                              @input="selectAgentOptions"
                                                              :placeholder="getLanguage['MT']['BN']"
                                                              :limitText="count => `+${count}`" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('AGIT','BN') }}</span>
                                        </CCol>
                                    </CRow>

                                    <table>
                                        <tr>
                                            <td><CButton @click="showAgentConfig(1)" color="primary" :class="agentconfig_LS ? 'mb-2 active' : 'mb-2'">{{this.getLanguage["ACU"]["LS"]}}</CButton></td>
                                            <!--Registration Setting Tab Button-->
                                            <!--<td v-if="bool_cr == false"><CButton @click="showAgentConfig(2)" color="primary" :class="agentconfig_RS ? 'mb-2 active' : 'mb-2'">{{this.getLanguage["ACU"]["RS"]}}</CButton></td>-->
                                            <td><CButton @click="showAgentConfig(3)" color="primary" :class="agentconfig_MSS ? 'mb-2 active' : 'mb-2'">{{this.getLanguage["ACU"]["MSS"]}}</CButton></td>
                                            <td><CButton @click="showAgentConfig(4)" color="primary" :class="agentconfig_BBOS ? 'mb-2 active' : 'mb-2'">{{this.getLanguage["ACU"]["BBOS"]}}</CButton></td>
                                            <td><CButton @click="showAgentConfig(5)" color="primary" :class="agentconfig_CS ? 'mb-2 active' : 'mb-2'">{{this.getLanguage["ACU"]["CS"]}}</CButton></td>
                                        </tr>
                                    </table>
                                    <div style="height:420px">
                                        <!--LOGIN SETTING DIV-->
                                        <CCollapse :show="agentconfig_LS">
                                            <CCard body-wrapper>
                                                <CRow>
                                                    <CCol col="12" class="mb-2">
                                                        <p class="h6">
                                                            {{this.getLanguage["ACU"]["LS"]}}
                                                        </p>
                                                        <div class='subHeaderHR'></div>
                                                    </CCol>
                                                    <CCol xl="6" class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.SL.CV" @change="v => arry_OnOff.SL.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.SL.CV" @change="handleToggleChange('SL')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["SL"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["SL"]}}</span>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="agentcus-grid" v-if="this.getUserInfo.AT == 0">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.LD.CV" @change="v => arry_OnOff.LD.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.LD.CV" @change="handleToggleChange('LD')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["ELD"]}} <span class="mandatory_Field">**</span></label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["ELD"]}}</span>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6">
                                                        <div class="flexcontainer">
                                                            <label class="col-form-label p-0">{{this.getLanguage["ACU"]["CO"]}} :</label>
                                                            <div>

                                                                <!-- Captcha Option 1: Alphabets Only -->
                                                                <!--<div class="flex-item agentcus-grid">
                                                                <input type="radio" name="captcha" checked="arry_OnOff.CCAOLN.CV" value="CCAOLN" @change="v => str_CaptchaOption = v.target.value" :style="renderStyle()">
                                                                <label for="html">{{this.getLanguage["ACO"]["AOLN"]}}</label>
                                                                <div class="custom_tooltip ACUZ_TT">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["AOLN"]}}</span>
                                                                </div>
                                                            </div>-->
                                                                <!-- Captcha Option 2: Alphanumeric -->
                                                                <!--<div class="flex-item agentcus-grid">
                                                                <input type="radio" name="captcha" :checked="arry_OnOff.CCALPN.CV" value="CCALPN" @change="v => str_CaptchaOption = v.target.value" :style="renderStyle()">
                                                                <label for="html">{{this.getLanguage["ACO"]["CCALPN"]}}</label>
                                                                <div class="custom_tooltip ACUZ_TT">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["CCALPN"]}}</span>
                                                                </div>
                                                            </div>-->
                                                                <!-- Captcha Option 3: Numeric Only -->
                                                                <!--<div class="flex-item agentcus-grid">
                                                                <input type="radio" name="captcha" :checked="arry_OnOff.CCNO.CV" value="CCNO" @change="v => str_CaptchaOption = v.target.value" :style="renderStyle()">
                                                                <label for="html">{{this.getLanguage["ACO"]["CCNO"]}}</label>
                                                                <div class="custom_tooltip ACUZ_TT">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["CCNO"]}}</span>
                                                                </div>
                                                            </div>-->
                                                                <!-- Captcha Option 4: Disable Captcha -->
                                                                <!--<div class="flex-item agentcus-grid">
                                                                <input type="radio" name="captcha" :checked="arry_OnOff.DCC.CV" value="DCC" @change="v => str_CaptchaOption = v.target.value" :style="renderStyle()">
                                                                <label for="html">{{this.getLanguage["ACO"]["DCC"]}}</label>
                                                                <div class="custom_tooltip ACUZ_TT">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["DCC"]}}</span>
                                                                </div>
                                                            </div>-->
                                                                <!-- Captcha Option 1: Alphabets Only -->
                                                                <!--<div class="flex-item agentcus-grid">
                                                                <input type="radio" name="captcha" value="CCAOLN" v-model="str_CaptchaOption" :style="renderStyle()">
                                                                <label>{{ this.getLanguage["ACO"]["AOLN"] }}</label>
                                                                <div class="custom_tooltip ACUZ_TT">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="tooltiptext2 turnover-requirement">{{ getLanguage["ACU"]["AOLN"] }}</span>
                                                                </div>
                                                            </div>-->
                                                                <!-- Captcha Option 2: Alphanumeric -->
                                                                <!--<div class="flex-item agentcus-grid">
                                                                <input type="radio" name="captcha" value="CCALPN" v-model="str_CaptchaOption" :style="renderStyle()">
                                                                <label>{{ this.getLanguage["ACO"]["CCALPN"] }}</label>
                                                                <div class="custom_tooltip ACUZ_TT">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="tooltiptext2 turnover-requirement">{{ getLanguage["ACU"]["CCALPN"] }}</span>
                                                                </div>
                                                            </div>-->
                                                                <!-- Captcha Option 3: Numeric Only -->
                                                                <!--<div class="flex-item agentcus-grid">
                                                                <input type="radio" name="captcha" value="CCNO" v-model="str_CaptchaOption" :style="renderStyle()">
                                                                <label>{{ this.getLanguage["ACO"]["CCNO"] }}</label>
                                                                <div class="custom_tooltip ACUZ_TT">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="tooltiptext2 turnover-requirement">{{ getLanguage["ACU"]["CCNO"] }}</span>
                                                                </div>
                                                            </div>-->
                                                                <!-- Captcha Option 4: Disable Captcha -->
                                                                <!--<div class="flex-item agentcus-grid">
                                                                <input type="radio" name="captcha" value="DCC" v-model="str_CaptchaOption" :style="renderStyle()">
                                                                <label>{{ this.getLanguage["ACO"]["DCC"] }}</label>
                                                                <div class="custom_tooltip ACUZ_TT">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="tooltiptext2 turnover-requirement">{{ getLanguage["ACU"]["DCC"] }}</span>
                                                                </div>
                                                            </div>-->
                                                                <!-- For Loop to generate all captcha options -->
                                                                <div v-for="option in captchaOptions" :key="option.value" class="flex-item agentcus-grid">
                                                                    <input type="radio"
                                                                           name="radioCaptcha"
                                                                           v-model="str_CaptchaOption"
                                                                           :value="option.value"
                                                                           :checked="option.value === str_CaptchaOption"
                                                                           :style="renderStyle()" />
                                                                    <label>{{ getLanguage["ACO"][option.languageKey] }}</label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{ getLanguage["ACU"][option.languageKey] }}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </CCol>

                                                    <!--=========== disable member site action =========-->
                                                    <CCol xl="6" v-if="this.getUserInfo.AT == 0">
                                                        <div class="flexcontainer">
                                                            <div class="agentcus-grid">
                                                                <label class="switch" :style="renderStyle()">
                                                                    <input type="checkbox" :checked="bool_DMSA" @change="v=>disableMemberSite(v.target.checked)">
                                                                    <span class="slider round"></span>
                                                                </label>
                                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["DMSA"]}}<span class="mandatory_Field">**</span></label>
                                                                <div class="custom_tooltip ACUZ_TT">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["DMSA"]}}</span>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <div class="flex-item agentcus-grid">
                                                                    <label class="switch">
                                                                        <!--<input type="checkbox" :checked="arry_OnOff.DMAL.CV" :disabled="!bool_DMSA" @change="v => arry_OnOff.DMAL.CV = v.target.checked">-->
                                                                        <input type="checkbox" :checked="arry_OnOff.DMAL.CV" :disabled="!bool_DMSA" @change="handleToggleChange('DMAL')">
                                                                        <span class="slider round" :style="[!bool_DMSA ?{'cursor':'not-allowed'}:{}]"></span>
                                                                    </label>
                                                                    <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["DMAL"]}}</label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["DMAL"]}}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="flex-item agentcus-grid">
                                                                    <label class="switch">
                                                                        <!--<input type="checkbox" :checked="arry_OnOff.DMAR.CV" :disabled="!bool_DMSA" @change="v => arry_OnOff.DMAR.CV = v.target.checked">-->
                                                                        <input type="checkbox" :checked="arry_OnOff.DMAR.CV" :disabled="!bool_DMSA" @change="handleToggleChange('DMAR')">
                                                                        <span class="slider round" :style="[!bool_DMSA ?{'cursor':'not-allowed'}:{}]"></span>
                                                                    </label>
                                                                    <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["DMAR"]}}</label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["DMAR"]}}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="flex-item agentcus-grid">
                                                                    <label class="switch">
                                                                        <!--<input type="checkbox" :checked="arry_OnOff.DMAD.CV" :disabled="!bool_DMSA" @change="v => arry_OnOff.DMAD.CV = v.target.checked">-->
                                                                        <input type="checkbox" :checked="arry_OnOff.DMAD.CV" :disabled="!bool_DMSA" @change="handleToggleChange('DMAD')">
                                                                        <span class="slider round" :style="[!bool_DMSA ?{'cursor':'not-allowed'}:{}]"></span>
                                                                    </label>
                                                                    <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["DMAD"]}}</label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["DMAD"]}}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="flex-item agentcus-grid">
                                                                    <label class="switch">
                                                                        <!--<input type="checkbox" :checked="arry_OnOff.DMAW.CV" :disabled="!bool_DMSA" @change="v => arry_OnOff.DMAW.CV = v.target.checked">-->
                                                                        <input type="checkbox" :checked="arry_OnOff.DMAW.CV" :disabled="!bool_DMSA" @change="handleToggleChange('DMAW')">
                                                                        <span class="slider round" :style="[!bool_DMSA ?{'cursor':'not-allowed'}:{}]"></span>
                                                                    </label>
                                                                    <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["DMAW"]}}</label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["DMAW"]}}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </CCol>

                                                    <!--=========== Enable Forgot Password Link =========-->
                                                    <CCol xl="6">
                                                        <div class="flexcontainer">
                                                            <div class="agentcus-grid">
                                                                <label class="switch" :style="renderStyle()">
                                                                    <!--<input type="checkbox" :checked="arry_OnOff.EFPL.CV" @change="v => arry_OnOff.EFPL.CV = v.target.checked">-->
                                                                    <input type="checkbox" :checked="arry_OnOff.EFPL.CV" @change="handleToggleChange('EFPL')">
                                                                    <span class="slider round"></span>
                                                                </label>
                                                                <label class="ACUZ_DO col-form-label">{{ getLanguage["ACO"]["EFPL"] }}</label>
                                                                <div class="custom_tooltip ACUZ_TT">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="tooltiptext2 turnover-requirement">{{ getLanguage["ACU"]["EFPL"] }}</span>
                                                                </div>
                                                            </div>
                                                            <div v-if="arry_OnOff.EFPL.CV">
                                                                <div class="flex-item agentcus-grid">
                                                                    <input type="radio"
                                                                           name="ForgotPasswordLinkOption"
                                                                           v-model="str_ForgotPasswordLinkOption"
                                                                           value="FPDTMB"
                                                                           :style="renderStyle()" />
                                                                    <label>{{ getLanguage["ACO"]["DTMB"] }}</label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{ getLanguage["ACU"]["DTMB"] }}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="flex-item agentcus-grid">
                                                                    <input type="radio"
                                                                           name="ForgotPasswordLinkOption"
                                                                           v-model="str_ForgotPasswordLinkOption"
                                                                           value="FPDT"
                                                                           :style="renderStyle()" />
                                                                    <label>{{ getLanguage["ACO"]["DT"] }}</label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{ getLanguage["ACU"]["DT"] }}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="flex-item agentcus-grid">
                                                                    <input type="radio"
                                                                           name="ForgotPasswordLinkOption"
                                                                           v-model="str_ForgotPasswordLinkOption"
                                                                           value="FPMB"
                                                                           :style="renderStyle()" />
                                                                    <label>{{ getLanguage["ACO"]["MB"] }}</label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{ getLanguage["ACU"]["MB"] }}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                </CRow>
                                            </CCard>
                                        </CCollapse>
                                        <!--LOGIN SETTING DIV END-->
                                        <!--REGISTRATION SETTING DIV-->
                                        <CCollapse :show="agentconfig_RS">
                                            <CCard body-wrapper>
                                                <CRow>
                                                    <CCol col="12" class="mb-2">
                                                        <p class="h6">
                                                            {{this.getLanguage["ACU"]["RS"]}}
                                                        </p>
                                                        <div class='subHeaderHR'></div>
                                                    </CCol>
                                                    <CCol xl="6" class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.RFWMP.CV" @change="v => arry_OnOff.RFWMP.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.RFWMP.CV" @change="handleToggleChange('RFWMP')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["RFWMP"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["RFWMP"]}}</span>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.RWBA.CV" @change="v => arry_OnOff.RWBA.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.RWBA.CV" @change="handleToggleChange('RWBA')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["RWBA"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["RWBA"]}}</span>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.RWEA.CV" @change="v => arry_OnOff.RWEA.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.RWEA.CV" @change="handleToggleChange('RWEA')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["RWEA"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["RWEA"]}}</span>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.CDBACC.CV" @change="v => arry_OnOff.CDBACC.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.CDBACC.CV" @change="handleToggleChange('CDBACC')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["CDBACC"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["CDBACC"]}}</span>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.CDPNO.CV" @change="v => arry_OnOff.CDPNO.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.CDPNO.CV" @change="handleToggleChange('CDPNO')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["CDPNO"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["CDPNO"]}}</span>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6">
                                                        <div class="flexcontainer">
                                                            <div class="agentcus-grid">
                                                                <label class="switch" :style="renderStyle()">
                                                                    <!--<input type="checkbox" :checked="arry_OnOff.RPN.CV" @change="v => arry_OnOff.RPN.CV = v.target.checked">-->
                                                                    <input type="checkbox" :checked="arry_OnOff.RPN.CV" @change="handleToggleChange('RPN')">
                                                                    <span class="slider round"></span>
                                                                </label>
                                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["RPN"]}}</label>
                                                                <div class="custom_tooltip ACUZ_TT">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["RPN"]}}</span>
                                                                </div>
                                                            </div>
                                                            <div v-if="arry_OnOff.RPN.CV == true">
                                                                <div class="flex-item agentcus-grid">
                                                                    <label :style="renderStyle()">
                                                                        <!--<input type="checkbox" :checked="arry_OnOff.DOTPV.CV" @change="v => arry_OnOff.DOTPV.CV = v.target.checked">-->
                                                                        <input type="checkbox" :checked="arry_OnOff.DOTPV.CV" @change="handleToggleChange('DOTPV')">
                                                                    </label>
                                                                    <label class="ACUZ_DO col-form-label">{{ this.getLanguage["ACO"]["DOTPV"] }}</label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{ this.getLanguage["ACU"]["DOTPV"] }}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="flex-item agentcus-grid">
                                                                    <!--<input type="radio" name="captcha" :checked="arry_OnOff.REGWPHONE.CV" value="true" @change="v => arry_OnOff.REGWPHONE.CV = true" :style="renderStyle()">-->
                                                                    <input type="radio" name="radioRegWPhone" :checked="arry_OnOff.REGWPHONE.CV" value="true" @change="handleToggleChange('REGWPHONE')" :style="renderStyle()">
                                                                    <label for="html">{{this.getLanguage["ACO"]["REGWPHONE"]}}</label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["REGWPHONE"]}}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="flex-item agentcus-grid">
                                                                    <!--<input type="radio" name="captcha" :checked="!arry_OnOff.REGWPHONE.CV" value="false" @change="v => arry_OnOff.REGWPHONE.CV = false" :style="renderStyle()">-->
                                                                    <input type="radio" name="radioRegWPhone" :checked="!arry_OnOff.REGWPHONE.CV" value="false" @change="handleToggleChange('REGWPHONE')" :style="renderStyle()">
                                                                    <label for="html">{{this.getLanguage["ACO"]["UANAU"]}}</label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["UANAU"]}}</span>
                                                                    </div>
                                                                </div>
                                                                <br />
                                                                <!--LOCALIZED-->
                                                                <div class="flex-item agentcus-grid">
                                                                    <label class="switch" :style="renderStyle()">
                                                                        <!--<input type="checkbox" :checked="arry_OnOff.ULPN.CV" @change="v => arry_OnOff.ULPN.CV = v.target.checked">-->
                                                                        <input type="checkbox" :checked="arry_OnOff.ULPN.CV" @change="handleToggleChange('ULPN')">
                                                                        <span class="slider round"></span>
                                                                    </label>
                                                                    <label class="ACUZ_DO col-form-label">{{ this.getLanguage["ACO"]["ULPN"] }}</label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{ this.getLanguage["ACU"]["ULPN"] }}</span>
                                                                    </div>
                                                                </div>

                                                                <!--PREFIX-->
                                                                <div class="flex-item agentcus-grid" v-if="arry_OnOff.ULPN.CV == true">
                                                                    <label class="switch" :style="renderStyle()">
                                                                        <!--<input type="checkbox" :checked="arry_OnOff.UPCODE.CV" @change="v => arry_OnOff.UPCODE.CV = v.target.checked">-->
                                                                        <input type="checkbox" :checked="arry_OnOff.UPCODE.CV" @change="handleToggleChange('UPCODE')">
                                                                        <span class="slider round"></span>
                                                                    </label>
                                                                    <label class="ACUZ_DO col-form-label">{{ this.getLanguage["ACO"]["UPCODE"] }}</label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{ this.getLanguage["ACU"]["UPCODE"] }}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="flex-item" v-if="arry_OnOff.ULPN.CV == true">
                                                                    <CInput class="inline inline30" :placeholder="getLanguage['ACO']['CCODE']" size="sm" :value="arry_aac.E_CC" @change="v => arry_aac.E_CC = v"></CInput>
                                                                    <CInput style="margin-left: 3px;" class="inline inline30" :placeholder="getLanguage['ACO']['PCODE']" size="sm" :value="arry_aac.E_PC" @change="v => arry_aac.E_PC = v"></CInput>
                                                                    <CButton style="margin-left: 15px; margin-top: 0px;" color="outline-dark" size="sm" class="btn-small inline inline10" @click="addPrefix()">
                                                                        <span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AD"]}}
                                                                    </CButton>
                                                                </div>
                                                                <br />
                                                                <div class="flex-item" v-if="arry_OnOff.ULPN.CV == true">
                                                                    <table class="custom-table custom-table-inPopUp afb-blue" style="width: 85% !important">
                                                                        <thead>
                                                                            <tr>
                                                                                <th v-if="!bool_isView" style="width: 30px;">{{ this.getLanguage['GL']['ACT'] }}</th>
                                                                                <th style="width: 50% !important">{{ this.getLanguage['ACO']['CCODE'] }}</th>
                                                                                <th>{{ this.getLanguage["ACO"]["PCODE"] }}</th>
                                                                                <th>{{ this.getLanguage["ACO"]["LDZ"] }}</th>
                                                                                <th>{{ this.getLanguage["ACO"]["PS"] }}</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                        <td colspan="100%" v-if="arry_aac.LocalisedList == 0 || !arry_aac.LocalisedList">{{ this.getLanguage['GL']['NR'] }}</td>
                                                                        <tr v-for="(data,index) in arry_aac.LocalisedList" class="">
                                                                            <td v-if="!bool_isView">
                                                                                <span id="actionBtnCol"> <i class="cil-trash" @click='removeLocaliseList(index)'></i> </span>
                                                                            </td>
                                                                            <td>+{{ data.CC }}</td>
                                                                            <td>{{ data.PC }}</td>
                                                                            <td>
                                                                                <input type="checkbox" v-if="data.PC != ''" :checked="data.LZ > 0" @click="tickLeadinZero($event, data, data.LZ, CountItem(index+1))" :style="renderStyle()" />
                                                                            </td>
                                                                            <td>+{{ data.PN }}</td>
                                                                        </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                                <br />
                                                            </div>
                                                        </div>
                                                    </CCol>

                                                    <!--BLOCK-->
                                                    <!--<CCol xl="6">
                                                    <div class="flexcontainer">
                                                        <div class="agentcus-grid">
                                                            <label class="switch" :style="renderStyle()">
                                                                <input type="checkbox" :checked="arry_OnOff.REGWPHONE.CV" @change="v => arry_OnOff.REGWPHONE.CV = v.target.checked">
                                                                <span class="slider round"></span>
                                                            </label>
                                                            <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["REGWPHONE"]}}</label>
                                                            <div class="custom_tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["REGWPHONE"]}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </CCol>-->
                                                    <!--LOCAL-->
                                                    <CCol xl="6">
                                                        <div class="agentcus-grid">
                                                            <label class="switch" :style="renderStyle()">
                                                                <!--<input type="checkbox" :checked="arry_OnOff.FNM.CV" @change="v => arry_OnOff.FNM.CV = v.target.checked">-->
                                                                <input type="checkbox" :checked="arry_OnOff.FNM.CV" @change="handleToggleChange('FNM')">
                                                                <span class="slider round"></span>
                                                            </label>
                                                            <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["FNM"]}}</label>
                                                            <div class="custom_tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["FNM"]}}</span>
                                                            </div>
                                                        </div>
                                                    </CCol>

                                                    <!--Hide Currency Dropdown If Having Only One Option-->
                                                    <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.HCDIHO.CV" @change="v => arry_OnOff.HCDIHO.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.HCDIHO.CV" @change="handleToggleChange('HCDIHO')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HCDIHO"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["HCDIHO"]}}</span>
                                                        </div>
                                                    </CCol>

                                                    <!--=== Enable UserID Numeric ==-->
                                                    <CCol xl="6" class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.EUN.CV" @change="v => arry_OnOff.EUN.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.EUN.CV" @change="handleToggleChange('EUN')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["UN"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["UN"]}}</span>
                                                        </div>
                                                    </CCol>

                                                    <!--=== Show referral code in member register form ==-->
                                                    <CCol xl="6" class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.SRC.CV" @change="v => arry_OnOff.SRC.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.SRC.CV" @change="handleToggleChange('SRC')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["SRC"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["SRC"]}}</span>
                                                        </div>
                                                    </CCol>
                                                    <!--=== Block All Black Listed Bank Account ==-->
                                                    <CCol xl="6" class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.BABLBA.CV" @change="v => arry_OnOff.BABLBA.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.BABLBA.CV" @change="handleToggleChange('BABLBA')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["BABLBA"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["BABLBA"]}}</span>
                                                        </div>
                                                    </CCol>
                                                    <!--=== Social Media ==-->
                                                    <CCol xl="6">
                                                        <div class="flexcontainer">
                                                            <div class="agentcus-grid">
                                                                <label class="switch" :style="renderStyle()">
                                                                    <!--<input type="checkbox" :checked="arry_OnOff.SM.CV" @change="v => arry_OnOff.SM.CV = v.target.checked">-->
                                                                    <input type="checkbox" :checked="arry_OnOff.SM.CV" @change="handleToggleChange('SM')">
                                                                    <span class="slider round"></span>
                                                                </label>
                                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["SM"]}}</label>
                                                                <div class="custom_tooltip ACUZ_TT">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["SM"]}}</span>
                                                                </div>
                                                            </div>
                                                            <div v-if="arry_OnOff.SM.CV == true">
                                                                <!--=== wechat, line, whatsapp, telegram, zalo  ==-->
                                                                <div class="flex-item agentcus-grid">
                                                                    <!--<input type="checkbox" name="captcha" :checked="arry_OnOff.WCID.CV" @change="v => arry_OnOff.WCID.CV = v.target.checked" :style="renderStyle()">-->
                                                                    <input type="checkbox" name="radioSocialMedia" :checked="arry_OnOff.WCID.CV" @change="handleToggleChange('WCID')" :style="renderStyle()">
                                                                    <label for="html">{{this.getLanguage["ACO"]["WC"]}} <span class="mandatory_Field">*</span></label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["WC"]}}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="flex-item agentcus-grid">
                                                                    <!--<input type="checkbox" name="captcha" :checked="arry_OnOff.LID.CV" @change="v => arry_OnOff.LID.CV = v.target.checked" :style="renderStyle()">-->
                                                                    <input type="checkbox" name="radioSocialMedia" :checked="arry_OnOff.LID.CV" @change="handleToggleChange('LID')" :style="renderStyle()">
                                                                    <label for="html">{{this.getLanguage["ACO"]["LID"]}} <span class="mandatory_Field">*</span></label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["LID"]}}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="flex-item agentcus-grid">
                                                                    <!--<input type="checkbox" name="captcha" :checked="arry_OnOff.WAID.CV" @change="v => arry_OnOff.WAID.CV = v.target.checked" :style="renderStyle()">-->
                                                                    <input type="checkbox" name="radioSocialMedia" :checked="arry_OnOff.WAID.CV" @change="handleToggleChange('WAID')" :style="renderStyle()">
                                                                    <label for="html">{{this.getLanguage["ACO"]["WAID"]}} <span class="mandatory_Field">*</span></label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["WAID"]}}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="flex-item agentcus-grid">
                                                                    <!--<input type="checkbox" name="captcha" :checked="arry_OnOff.TGID.CV" @change="v => arry_OnOff.TGID.CV = v.target.checked" :style="renderStyle()">-->
                                                                    <input type="checkbox" name="radioSocialMedia" :checked="arry_OnOff.TGID.CV" @change="handleToggleChange('TGID')" :style="renderStyle()">
                                                                    <label for="html">{{this.getLanguage["ACO"]["TGID"]}} <span class="mandatory_Field">*</span></label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["TGID"]}}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="flex-item agentcus-grid">
                                                                    <!--<input type="checkbox" name="captcha" :checked="arry_OnOff.ZLID.CV" @change="v => arry_OnOff.ZLID.CV = v.target.checked" :style="renderStyle()">-->
                                                                    <input type="checkbox" name="radioSocialMedia" :checked="arry_OnOff.ZLID.CV" @change="handleToggleChange('ZLID')" :style="renderStyle()">
                                                                    <label for="html">{{this.getLanguage["ACO"]["ZLID"]}} <span class="mandatory_Field">*</span></label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["ZLID"]}}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                </CRow>
                                            </CCard>
                                        </CCollapse>
                                        <!--REGISTRATION SETTING DIV END-->
                                        <!--MEMBER SITE SETTING DIV-->
                                        <CCollapse :show="agentconfig_MSS">
                                            <CCard body-wrapper>
                                                <CRow>
                                                    <CCol col="12" class="mb-2">
                                                        <p class="h6">
                                                            {{this.getLanguage["ACU"]["MSS"]}}
                                                        </p>
                                                        <div class='subHeaderHR'></div>
                                                    </CCol>

                                                    <CCol xl="6" class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.LMIAA.CV" @change="v => arry_OnOff.LMIAA.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.LMIAA.CV" @change="handleToggleChange('LMIAA')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["LMIAA"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["LMIAA"]}}</span>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.HSCM.CV" @change="v => arry_OnOff.HSCM.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.HSCM.CV" @change="handleToggleChange('HSCM')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HSCM"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["HSCM"]}}</span>
                                                        </div>
                                                    </CCol>
                                                    <!--Enable Floating Left QR Code-->
                                                    <CCol xl="6" v-if='ShowFullAgentConfig'>
                                                        <div class="flexcontainer">
                                                            <div class="agentcus-grid">
                                                                <label class="switch" :style="renderStyle()">
                                                                    <input type="checkbox" :checked="bool_HFLQRC" @change="v=> bool_HFLQRC = v.target.checked">
                                                                    <span class="slider round"></span>
                                                                </label>
                                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HSQRCM"]}}</label>
                                                                <div class="custom_tooltip ACUZ_TT">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["HSQRCM"]}}</span>
                                                                </div>
                                                            </div>
                                                            <div v-if="bool_HFLQRC">
                                                                <div class="flex-item agentcus-grid">
                                                                    <input type="checkbox" :checked="arry_OnOff.HQRCBL.CV" @change="handleToggleChange('HQRCBL')">
                                                                    <label>{{this.getLanguage["PV"]["DBL"]}}</label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["PV"]["DBL"]}}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="flex-item agentcus-grid">
                                                                    <input type="checkbox" :checked="arry_OnOff.HSQRCM.CV" @change="handleToggleChange('HSQRCM')">
                                                                    <label>{{this.getLanguage["PV"]["DAL"]}}</label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["PV"]["DAL"]}}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.SQRCSM.CV" @change="v => arry_OnOff.SQRCSM.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.SQRCSM.CV" @change="handleToggleChange('SQRCSM')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["SQRCSM"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["SQRCSM"]}}</span>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.HICSM.CV" @change="v => arry_OnOff.HICSM.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.HICSM.CV" @change="handleToggleChange('HICSM')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HICSM"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["HICSM"]}}</span>
                                                        </div>
                                                    </CCol>

                                                    <CCol xl="6" class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.HBLPU.CV" @change="v => arry_OnOff.HBLPU.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.HBLPU.CV" @change="handleToggleChange('HBLPU')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HBLPU"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["HBLPU"]}}</span>
                                                        </div>
                                                    </CCol>

                                                    <CCol xl="6" class="agentcus-grid" v-if="this.getUserInfo.AT == 0">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.DWOTT.CV" @change="v => arry_OnOff.DWOTT.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.DWOTT.CV" @change="handleToggleChange('DWOTT')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["TAW"]}} <span class="mandatory_Field">**</span></label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["TAW"]}}</span>
                                                        </div>
                                                    </CCol>

                                                    <CCol xl="6" class="agentcus-grid" v-if="ShowFullAgentConfig">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.DODDS.CV" @change="v => arry_OnOff.DODDS.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.DODDS.CV" @change="handleToggleChange('DODDS')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["ESOMS"]}} </label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["ESOMS"]}}</span>
                                                        </div>

                                                        <div v-if="arry_OnOff.DODDS.CV">
                                                            <div class="flex-item" style="display: grid; grid-template-columns: 140px 150px; gap: 5px;">
                                                                <label class="ACUZ_DO col-form-label">
                                                                    {{this.getLanguage["ACO"]["SOT"]}}
                                                                </label>
                                                                <customtreeselect v-model="selectedSOTValue"
                                                                                  :options="sportOddsTypeOptions"
                                                                                  :multiple="false"
                                                                                  :flat="true"
                                                                                  @input="selectedTOValue = null"
                                                                                  :placeholder="getLanguage['ACO']['SOT']" />
                                                            </div>
                                                            <div class="flex-item" style="display: grid; grid-template-columns: 140px 150px 45px; gap: 5px;">
                                                                <label class="ACUZ_DO col-form-label">
                                                                    {{this.getLanguage["ACO"]["TO"]}}
                                                                </label>
                                                                <customtreeselect v-model="selectedTOValue"
                                                                                  :options="filteredThemeOptions"
                                                                                  :multiple="false"
                                                                                  :flat="true"
                                                                                  :placeholder="getLanguage['ACO']['TO']" />
                                                                <div class="input-group-append" @click="previewImgUrl = 'https://media.afb.gg/SportOdd/'+selectedSOTValue+selectedTOValue+'.png'" :style="(selectedTOValue && sportOddsTypeOptions) ? '' : 'visibility:hidden ' " style="height: calc(1.5em + .4rem + 2px) !important;font-size: .76563rem;">
                                                                    <label class="input-group-text pointer" style=" border-radius: 5px !important;"><i class="fa fa-eye"></i></label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </CCol>

                                                    <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.EAFBFHP.CV" @change="v => arry_OnOff.EAFBFHP.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.EAFBFHP.CV" @change="handleToggleChange('EAFBFHP')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["EAFBFHP"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["EAFBFHP"]}}</span>
                                                        </div>
                                                    </CCol>

                                                    <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.DDNF.CV" @change="v => arry_OnOff.DDNF.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.DDNF.CV" @change="handleToggleChange('DDNF')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["DDNF"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["DDNF"]}}</span>
                                                        </div>
                                                    </CCol>

                                                    <!--=== Mask Downline Member Name in Affiliate ==-->
                                                    <CCol xl="6" class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.MDMIA.CV" @change="v => arry_OnOff.MDMIA.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.MDMIA.CV" @change="handleToggleChange('MDMIA')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["MDMIA"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["MDMIA"]}}</span>
                                                        </div>
                                                    </CCol>
                                                    <!--=== Hide Main Affiliate Name ==-->
                                                    <CCol xl="6" class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.HMAN.CV" @change="v => arry_OnOff.HMAN.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.HMAN.CV" @change="handleToggleChange('HMAN')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HMAN"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["HMAN"]}}</span>
                                                        </div>
                                                    </CCol>
                                                    <!--=== Hide Affiliate Tiering Table ==-->
                                                    <CCol xl="6" class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.HATT.CV" @change="v => arry_OnOff.HATT.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.HATT.CV" @change="handleToggleChange('HATT')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HATT"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["HATT"]}}</span>
                                                        </div>
                                                    </CCol>
                                                    <!--=== Allow free trial on top 5 games ==-->
                                                    <CCol xl="6">
                                                        <div class="flexcontainer">
                                                            <div class="agentcus-grid">
                                                                <label class="switch" :style="renderStyle()">
                                                                    <!--<input type="checkbox" :checked="arry_OnOff.AFTTFG.CV" @change="v => arry_OnOff.AFTTFG.CV = v.target.checked" :style="renderStyle()" @click="AFTTFG(!arry_OnOff.AFTTFG.CV)">-->
                                                                    <input type="checkbox" :checked="arry_OnOff.AFTTFG.CV" @change="handleToggleChange('AFTTFG')" :style="renderStyle()" @click="AFTTFG(!arry_OnOff.AFTTFG.CV)">
                                                                    <span class="slider round"></span>
                                                                </label>
                                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["AFTTFG"]}}</label>
                                                                <div class="custom_tooltip ACUZ_TT">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["AFTTFG"]}}</span>
                                                                </div>
                                                            </div>

                                                            <div v-if="arry_OnOff.AFTTFG.CV == true">
                                                                <div class="flex-item agentcus-grid">
                                                                    <!--<input type="checkbox" name="captcha" :checked="arry_OnOff.HFTGBL.CV" @change="v => arry_OnOff.HFTGBL.CV = v.target.checked" :style="renderStyle()">-->
                                                                    <input type="checkbox" name="radioFreeTrial" :checked="arry_OnOff.HFTGBL.CV" @change="handleToggleChange('HFTGBL')" :style="renderStyle()">
                                                                    <label for="html">{{this.getLanguage["ACO"]["HFTGBL"]}}</label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["HFTGBL"]}}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="flex-item agentcus-grid">
                                                                    <!--<input type="checkbox" name="captcha" :checked="arry_OnOff.HFTGAL.CV" @change="v => arry_OnOff.HFTGAL.CV = v.target.checked" :style="renderStyle()">-->
                                                                    <input type="checkbox" name="radioFreeTrial" :checked="arry_OnOff.HFTGAL.CV" @change="handleToggleChange('HFTGAL')" :style="renderStyle()">
                                                                    <label for="html">{{this.getLanguage["ACO"]["HFTGAL"]}}</label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["HFTGAL"]}}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </CCol>

                                                    <!--=== Disable System Auto Block ==-->
                                                    <CCol xl="6" v-if="this.getUserInfo.AT == 0">
                                                        <div class="flexcontainer">
                                                            <div class="agentcus-grid">
                                                                <label class="switch" :style="renderStyle()">
                                                                    <!--<input type="checkbox" :checked="arry_OnOff.DSAB.CV" @change="v => arry_OnOff.DSAB.CV = v.target.checked">-->
                                                                    <input type="checkbox" :checked="arry_OnOff.DSAB.CV" @change="handleToggleChange('DSAB')">
                                                                    <span class="slider round"></span>
                                                                </label>
                                                                <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["DSAB"]}} <span class="mandatory_Field">**</span></label>
                                                                <div class="custom_tooltip ACUZ_TT">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["DSAB"]}}</span>
                                                                </div>
                                                            </div>
                                                            <div v-if="arry_OnOff.DSAB.CV == false">
                                                                <div class="flex-item" style="display: grid; grid-template-columns: 140px auto; ">
                                                                    <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACU"]["ID"]}}</label>
                                                                    <CInput class="inline inline30" :placeholder="getLanguage['ACU']['ID']" size="sm" :value="arry_aac.InactiveDays" @change="v => arry_aac.InactiveDays = v" :style="renderStyle()"></CInput>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.DDLS.CV" @change="v => arry_OnOff.DDLS.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.DDLS.CV" @change="handleToggleChange('DDLS')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["DDLS"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["DDLS"]}}</span>
                                                        </div>
                                                    </CCol>

                                                    <!--=== launch a game in iframe or in new tab ==-->
                                                    <CCol xl="6">
                                                        <div class="flexcontainer">
                                                            <div class="agentcus-grid">
                                                                <label class="switch" :style="renderStyle()">
                                                                    <!--<input type="checkbox" :checked="arry_OnOff.GLIF.CV" @change="v => arry_OnOff.GLIF.CV = v.target.checked">-->
                                                                    <input type="checkbox" :checked="arry_OnOff.GLIF.CV" @change="handleToggleChange('GLIF')">
                                                                    <span class="slider round"></span>
                                                                </label>
                                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["GLIF"]}}</label>
                                                                <div class="custom_tooltip ACUZ_TT">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["GLIF"]}}</span>
                                                                </div>
                                                            </div>
                                                            <div v-if="arry_OnOff.GLIF.CV == true && this.getUserInfo.AT == 0">
                                                                <div class="flex-item agentcus-grid">
                                                                    <!--<input type="checkbox" :checked="arry_OnOff.GLIFSW.CV" @change="v => arry_OnOff.GLIFSW.CV = v.target.checked">-->
                                                                    <input type="checkbox" :checked="arry_OnOff.GLIFSW.CV" @change="handleToggleChange('GLIFSW')">
                                                                    <label for="html">{{this.getLanguage["ACO"]["GLIFSW"]}}<span class="mandatory_Field">**</span></label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["GLIFSW"]}}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                    <!--=== hide last5 game history ==-->
                                                    <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.HL5GH.CV" @change="v => arry_OnOff.HL5GH.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.HL5GH.CV" @change="handleToggleChange('HL5GH')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HL5GH"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["HL5GH"]}}</span>
                                                        </div>
                                                    </CCol>
                                                    <!--=== hide top5 ranking tournament (langding page)==-->
                                                    <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.HTR.CV" @change="v => arry_OnOff.HTR.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.HTR.CV" @change="handleToggleChange('HTR')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HTR"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["HTR"]}}</span>
                                                        </div>
                                                    </CCol>

                                                    <!--=========== Enable Tournament Bottom Navigation =========-->
                                                    <CCol xl="6">
                                                        <div class="flexcontainer">
                                                            <div class="agentcus-grid">
                                                                <label class="switch" :style="renderStyle()">
                                                                    <!--<input type="checkbox" :checked="arry_OnOff.ETBN.CV" @change="v => arry_OnOff.ETBN.CV = v.target.checked">-->
                                                                    <input type="checkbox" :checked="arry_OnOff.ETBN.CV" @change="handleToggleChange('ETBN')">
                                                                    <span class="slider round"></span>
                                                                </label>
                                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["ETBN"]}}</label>
                                                                <div class="custom_tooltip ACUZ_TT">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["ETBN"]}}</span>
                                                                </div>
                                                            </div>
                                                            <div v-if="arry_OnOff.ETBN.CV">
                                                                <div class="flex-item agentcus-grid">
                                                                    <input type="radio"
                                                                           name="TournamentNavOption"
                                                                           v-model="str_TournamentNavOption"
                                                                           value="DTMB"
                                                                           :style="renderStyle()" />
                                                                    <label>{{ getLanguage["ACO"]["DTMB"] }}</label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{ getLanguage["ACU"]["DTMB"] }}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="flex-item agentcus-grid">
                                                                    <input type="radio"
                                                                           name="TournamentNavOption"
                                                                           v-model="str_TournamentNavOption"
                                                                           value="DT"
                                                                           :style="renderStyle()" />
                                                                    <label>{{ getLanguage["ACO"]["DT"] }}</label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{ getLanguage["ACU"]["DT"] }}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="flex-item agentcus-grid">
                                                                    <input type="radio"
                                                                           name="TournamentNavOption"
                                                                           v-model="str_TournamentNavOption"
                                                                           value="MB"
                                                                           :style="renderStyle()" />
                                                                    <label>{{ getLanguage["ACO"]["MB"] }}</label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{ getLanguage["ACU"]["MB"] }}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </CCol>

                                                    <!--=========== Enable Tournament Bottom Navigation End =========-->
                                                    <!--=== Disable Game Provider Lobbies ===-->
                                                    <CCol xl="6" style="display: none;">
                                                        <div class="flexcontainer">
                                                            <div class="agentcus-grid">
                                                                <label class="switch" :style="renderStyle()">
                                                                    <input type="checkbox" :checked="arry_OnOff.DGPL.CV" @change="onDisableGameProviderLobbiessChanged($event)">
                                                                    <span class="slider round"></span>
                                                                </label>
                                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["DGPL"]}}</label>
                                                                <div class="custom_tooltip ACUZ_TT">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["DGPL"]}}</span>
                                                                </div>
                                                            </div>
                                                            <div v-if="arry_OnOff.DGPL.CV == false">
                                                                <div class="flex-item">
                                                                    <treeselect :multiple="true"
                                                                                :options="dd_gameprovider"
                                                                                :placeholder="getLanguage['GL']['ALL']"
                                                                                v-model="arry_aac.DisabledProviderLobbies"
                                                                                :defaultExpandLevel="1"
                                                                                valueConsistsOf="LEAF_PRIORITY" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </CCol>

                                                    <!--=== Disable System Auto Block ==-->
                                                    <CCol xl="6" v-if="this.getUserInfo.AT == 0">
                                                        <div class="flexcontainer">
                                                            <div class="agentcus-grid">
                                                                <label class="switch" :style="renderStyle()">
                                                                    <!--<input type="checkbox" :checked="arry_OnOff.EASF.CV" @change="v => arry_OnOff.EASF.CV = v.target.checked">-->
                                                                    <input type="checkbox" :checked="arry_OnOff.EASF.CV" @change="handleToggleChange('EASF')">
                                                                    <span class="slider round"></span>
                                                                </label>
                                                                <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["EASF"]}} <span class="mandatory_Field">**</span></label>
                                                                <div class="custom_tooltip ACUZ_TT">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["EASF"]}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                    <!--=== Enable full membersite version ===-->
                                                    <CCol xl="6" class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.EFV.CV" @change="v => arry_OnOff.EFV.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.EFV.CV" @change="handleToggleChange('EFV')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["EFV"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["EFV"]}}</span>
                                                        </div>
                                                    </CCol>

                                                    <!--=== Enable Game Provider lobby (only for Live Casino) ==-->
                                                    <CCol xl="6">
                                                        <div class="flexcontainer">
                                                            <div class="agentcus-grid">
                                                                <label class="switch" :style="renderStyle()">
                                                                    <!--<input type="checkbox" :checked="arry_OnOff.EGPLL.CV" @change="v => arry_OnOff.EGPLL.CV = v.target.checked">-->
                                                                    <input type="checkbox" :checked="arry_OnOff.EGPLL.CV" @change="handleToggleChange('EGPLL')">
                                                                    <span class="slider round"></span>
                                                                </label>
                                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["EGPLL"]}}</label>
                                                                <div class="custom_tooltip ACUZ_TT">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["EGPLL"]}}</span>
                                                                </div>
                                                            </div>
                                                            <div v-if="arry_OnOff.EGPLL.CV == true">
                                                                <div class="flex-item agentcus-grid">
                                                                    <!--<input type="checkbox" :checked="arry_OnOff.DLGFML.CV" @change="v => arry_OnOff.DLGFML.CV = v.target.checked">-->
                                                                    <input type="checkbox" :checked="arry_OnOff.DLGFML.CV" @change="handleToggleChange('DLGFML')">
                                                                    <label for="html">{{this.getLanguage["ACO"]["DLGFML"]}}</label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["DLGFML"]}}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </CCol>

                                                    <!--=== Enable Userful Link ===-->
                                                    <CCol xl="6" class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <input type="checkbox" :checked="arry_OnOff.EUL.CV" @change="handleToggleChange('EUL')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["EUL"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["EUL"]}}</span>
                                                        </div>
                                                    </CCol>

                                                    <!--=== Home Page Top 5 Game Setting ===-->
                                                    <CCol col="12" class="my-2" v-if='ShowFullAgentConfig'>
                                                        <p class="h6">
                                                            {{this.getLanguage["ACU"]["HPT5GS"]}}
                                                        </p>
                                                        <div class='subHeaderHR'></div>
                                                    </CCol>
                                                    <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.HT5J.CV" @change="v => arry_OnOff.HT5J.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.HT5J.CV" @change="handleToggleChange('HT5J')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HT5J"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["HT5J"]}}</span>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.HT5S.CV" @change="v => arry_OnOff.HT5S.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.HT5S.CV" @change="handleToggleChange('HT5S')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HT5S"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["HT5S"]}}</span>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.HT5LC.CV" @change="v => arry_OnOff.HT5LC.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.HT5LC.CV" @change="handleToggleChange('HT5LC')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HT5LC"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["HT5LC"]}}</span>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.HT5SES.CV" @change="v => arry_OnOff.HT5SES.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.HT5SES.CV" @change="handleToggleChange('HT5SES')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HT5SES"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["HT5SES"]}}</span>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.HT5DG.CV" @change="v => arry_OnOff.HT5DG.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.HT5DG.CV" @change="handleToggleChange('HT5DG')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HT5DG"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["HT5DG"]}}</span>
                                                        </div>
                                                    </CCol>
                                                </CRow>
                                            </CCard>
                                        </CCollapse>
                                        <!--MEMBER SITE SETTING DIV END-->
                                        <!--BANK & BACK-OFFICE SETTING DIV-->
                                        <CCollapse :show="agentconfig_BBOS">
                                            <CCard body-wrapper>
                                                <CRow>
                                                    <CCol col="12" class="mb-2">
                                                        <!--=== Bank Setting ===-->
                                                        <p class="h6">
                                                            {{this.getLanguage["ACU"]["BST"]}}
                                                        </p>
                                                        <div class='subHeaderHR'></div>
                                                    </CCol>

                                                    <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.NADBABA.CV" @change="v => arry_OnOff.NADBABA.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.NADBABA.CV" @change="handleToggleChange('NADBABA')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["NADBABA"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["NADBABA"]}}</span>
                                                        </div>
                                                    </CCol>

                                                    <CCol xl="6" class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.DDB.CV" @change="v => arry_OnOff.DDB.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.DDB.CV" @change="handleToggleChange('DDB')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["DDB"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["DDB"]}}</span>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.NAABA.CV" @change="v => arry_OnOff.NAABA.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.NAABA.CV" @change="handleToggleChange('NAABA')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["NAABA"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["NAABA"]}}</span>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.NADBA.CV" @change="v => arry_OnOff.NADBA.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.NADBA.CV" @change="handleToggleChange('NADBA')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["NADBA"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["NADBA"]}}</span>
                                                        </div>
                                                    </CCol>

                                                    <CCol xl="6" class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.NBRWD.CV" @change="v => arry_OnOff.NBRWD.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.NBRWD.CV" @change="handleToggleChange('NBRWD')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["NBRWD"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["NBRWD"]}}</span>
                                                        </div>
                                                    </CCol>

                                                    <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.OWB.CV" @change="v => arry_OnOff.OWB.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.OWB.CV" @change="handleToggleChange('OWB')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["OWB"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["OWB"]}}</span>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.SSMRB.CV" @change="v => arry_OnOff.SSMRB.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.SSMRB.CV" @change="handleToggleChange('SSMRB')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["SSMRB"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["SSMRB"]}}</span>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.SHBAN.CV" @change="v => arry_OnOff.SHBAN.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.SHBAN.CV" @change="handleToggleChange('SHBAN')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["SHBAN"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["SHBAN"]}}</span>
                                                        </div>
                                                    </CCol>

                                                    <!------------ Hide Manual Deposit Option ------------>
                                                    <!--<CCol xl="6" class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">-->
                                                    <!--<input type="checkbox" :checked="arry_OnOff.HMDO.CV" @change="v => arry_OnOff.HMDO.CV = v.target.checked">-->
                                                    <!--<input type="checkbox" :checked="arry_OnOff.HMDO.CV" @change="handleToggleChange('HMDO')">
                                                        <span class="slider round"></span>
                                                    </label>
                                                    <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HMDO"]}}</label>
                                                    <div class="custom_tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["HMDO"]}}</span>
                                                    </div>
                                                </CCol>-->
                                                    <!--<CCol xl="6" v-if='ShowFullAgentConfig'>
                                                <div class="flexcontainer">
                                                    <div class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">-->
                                                    <!--<input type="checkbox" :checked="arry_OnOff.PDO.CV" @change="v => arry_OnOff.PDO.CV = v.target.checked">-->
                                                    <!--<input type="checkbox" :checked="arry_OnOff.PDO.CV" @change="handleToggleChange('PDO')">
                                                        <span class="slider round"></span>
                                                    </label>
                                                    <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["PDO"]}}</label>
                                                    <div class="custom_tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["PDO"]}}</span>
                                                    </div>
                                                </div>-->
                                                    <!-- Deposit Options -->
                                                    <!--<div v-if="arry_OnOff.PDO.CV == true">
                                                <div class="flex-item agentcus-grid">
                                                    <input type="radio" name="PreferredDeposit" :checked="arry_OnOff.MD.CV" value="MD" @change="v => str_PreferredDepositOption = v.target.value" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["MD"]}}</label>
                                                    <div class="custom_tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["MD"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-item agentcus-grid">
                                                    <input type="radio" name="PreferredDeposit" :checked="arry_OnOff.AD.CV" value="AD" @change="v => str_PreferredDepositOption = v.target.value" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["AD"]}}</label>
                                                    <div class="custom_tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["AD"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-item agentcus-grid">
                                                    <input type="radio" name="PreferredDeposit" :checked="arry_OnOff.ADP.CV" value="ADP" @change="v => str_PreferredDepositOption = v.target.value" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["ADP"]}}</label>
                                                    <div class="custom_tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["ADP"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-item agentcus-grid">
                                                    <input type="radio" name="PreferredDeposit" :checked="arry_OnOff.HP.CV" value="HP" @change="v => str_PreferredDepositOption = v.target.value" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["HP"]}}</label>
                                                    <div class="custom_tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["HP"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-item agentcus-grid">
                                                    <input type="radio" name="PreferredDeposit" :checked="arry_OnOff.OP.CV" value="OP" @change="v => str_PreferredDepositOption = v.target.value" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["OP"]}}</label>
                                                    <div class="custom_tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["OP"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-item agentcus-grid">
                                                    <input type="radio" name="PreferredDeposit" :checked="arry_OnOff.EZP.CV" value="EZP" @change="v => str_PreferredDepositOption = v.target.value" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["EZP"]}}</label>
                                                    <div class="custom_tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["EZP"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-item agentcus-grid">
                                                    <input type="radio" name="PreferredDeposit" :checked="arry_OnOff.TUP.CV" value="TUP" @change="v => str_PreferredDepositOption = v.target.value" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["TUP"]}}</label>
                                                    <div class="custom_tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["TUP"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-item agentcus-grid">
                                                    <input type="radio" name="PreferredDeposit" :checked="arry_OnOff.CT.CV" value="CT" @change="v => str_PreferredDepositOption = v.target.value" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["CT"]}}</label>
                                                    <div class="custom_tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["CT"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-item agentcus-grid">
                                                    <input type="radio" name="PreferredDeposit" :checked="arry_OnOff.XFU.CV" value="XFU" @change="v => str_PreferredDepositOption = v.target.value" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["XFU"]}}</label>
                                                    <div class="custom_tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["XFU"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-item agentcus-grid">
                                                    <input type="radio" name="PreferredDeposit" :checked="arry_OnOff.STP.CV" value="STP" @change="v => str_PreferredDepositOption = v.target.value" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["STP"]}}</label>
                                                    <div class="custom_tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["STP"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-item agentcus-grid">
                                                    <input type="radio" name="PreferredDeposit" :checked="arry_OnOff.SUREP.CV" value="SUREP" @change="v => str_PreferredDepositOption = v.target.value" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["SUREP"]}}</label>
                                                    <div class="custom_tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["SUREP"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-item agentcus-grid">-->
                                                    <!--918Pay-->
                                                    <!--<input type="radio" name="PreferredDeposit" :checked="arry_OnOff.P918.CV" value="P918" @change="v => str_PreferredDepositOption = v.target.value" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["918P"]}}</label>
                                                    <div class="custom_tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["P918"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-item agentcus-grid">
                                                    <input type="radio" name="PreferredDeposit" :checked="arry_OnOff.FUP.CV" value="FUP" @change="v => str_PreferredDepositOption = v.target.value" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["FUP"]}}</label>
                                                    <div class="custom_tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["FUP"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-item agentcus-grid">
                                                    <input type="radio" name="PreferredDeposit" :checked="arry_OnOff.TMONEY.CV" value="TMONEY" @change="v => str_PreferredDepositOption = v.target.value" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["TMONEY"]}}</label>
                                                    <div class="custom_tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["TMONEY"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-item agentcus-grid">
                                                    <input type="radio" name="PreferredDeposit" :checked="arry_OnOff.SMP.CV" value="SMP" @change="v => str_PreferredDepositOption = v.target.value" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["SMP"]}}</label>
                                                    <div class="custom_tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["SMP"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-item agentcus-grid">
                                                    <input type="radio" name="PreferredDeposit" :checked="arry_OnOff.U2P.CV" value="U2P" @change="v => str_PreferredDepositOption = v.target.value" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["U2P"]}}</label>
                                                    <div class="custom_tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["U2P"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-item agentcus-grid">
                                                    <input type="radio" name="PreferredDeposit" :checked="arry_OnOff.LP.CV" value="LP" @change="v => str_PreferredDepositOption = v.target.value" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["LP"]}}</label>
                                                    <div class="custom_tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["LP"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-item agentcus-grid">
                                                    <input type="radio" name="PreferredDeposit" :checked="arry_OnOff.BCP.CV" value="BCP" @change="v => str_PreferredDepositOption = v.target.value" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["BCP"]}}</label>
                                                    <div class="custom_tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["BCP"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-item agentcus-grid">
                                                    <input type="radio" name="PreferredDeposit" :checked="arry_OnOff.FPG.CV" value="FPG" @change="v => str_PreferredDepositOption = v.target.value" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["FPG"]}}</label>
                                                    <div class="custom_tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["FPG"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-item agentcus-grid">
                                                    <input type="radio" name="PreferredDeposit" :checked="arry_OnOff.PGA.CV" value="PGA" @change="v => str_PreferredDepositOption = v.target.value" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["PGA"]}}</label>
                                                    <div class="custom_tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["PGA"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-item agentcus-grid">-->
                                                    <!--Pompay-->
                                                    <!--<input type="radio" name="PreferredDeposit" :checked="arry_OnOff.PP.CV" value="PP" @change="v => str_PreferredDepositOption = v.target.value" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["PP"]}}</label>
                                                    <div class="custom_tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["PP"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-item agentcus-grid">-->
                                                    <!--DoitNow-->
                                                    <!--<input type="radio" name="PreferredDeposit" :checked="arry_OnOff.DN.CV" value="DN" @change="v => str_PreferredDepositOption = v.target.value" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["DN"]}}</label>
                                                    <div class="custom_tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["DN"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-item agentcus-grid">-->
                                                    <!--AgogoPay-->
                                                    <!--<input type="radio" name="PreferredDeposit" :checked="arry_OnOff.AGP.CV" value="AGP" @change="v => str_PreferredDepositOption = v.target.value" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["AGP"]}}</label>
                                                    <div class="custom_tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["AGP"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-item agentcus-grid">-->
                                                    <!--UniversePay-->
                                                    <!--<input type="radio" name="PreferredDeposit" :checked="arry_OnOff.UP.CV" value="UP" @change="v => str_PreferredDepositOption = v.target.value" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["UP"]}}</label>
                                                    <div class="custom_tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["UP"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-item agentcus-grid">-->
                                                    <!--Megaspay-->
                                                    <!--<input type="radio" name="PreferredDeposit" :checked="arry_OnOff.OKP.CV" value="OKP" @change="v => str_PreferredDepositOption = v.target.value" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["OKP"]}}</label>
                                                    <div class="custom_tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["OKP"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-item agentcus-grid">-->
                                                    <!--Okayspay-->
                                                    <!--<input type="radio" name="PreferredDeposit" :checked="arry_OnOff.MGP.CV" value="MGP" @change="v => str_PreferredDepositOption = v.target.value" :style="renderStyle()">
                                                        <label for="html">{{this.getLanguage["ACO"]["MGP"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["MGP"]}}</span>
                                                        </div>
                                                    </div>
                                                </div>-->
                                                    <!-- For Loop to generate Radio List, check depositOptions data array -->
                                                    <!--<div v-if="arry_OnOff.PDO.CV">
                                                            <div v-for="option in depositOptions" :key="option.value" class="flex-item agentcus-grid">
                                                                <input type="radio"
                                                                       name="radioPrefDeposit"
                                                                       v-model="str_PreferredDepositOption"
                                                                       :value="option.value"
                                                                       :style="renderStyle()" />
                                                                <label>{{ getLanguage["ACO"][option.languageKey] }}</label>
                                                                <div class="custom_tooltip ACUZ_TT">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="tooltiptext2 turnover-requirement">{{ getLanguage["ACU"][option.languageKey] }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </CCol>-->
                                                    <!----END-------- Hide Manual Deposit Option ------------>
                                                    <CCol xl="6" v-if="arry_OnOff.FNM.CV == true">
                                                        <div class="agentcus-grid">
                                                            <label class="switch" :style="renderStyle()">
                                                                <!--<input type="checkbox" :checked="arry_OnOff.FNABAN.CV" @change="v => arry_OnOff.FNABAN.CV = v.target.checked">-->
                                                                <input type="checkbox" :checked="arry_OnOff.FNABAN.CV" @change="handleToggleChange('FNABAN')">
                                                                <span class="slider round"></span>
                                                            </label>
                                                            <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["FNABAN"]}}</label>
                                                            <div class="custom_tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["FNABAN"]}}</span>
                                                            </div>
                                                        </div>
                                                    </CCol>

                                                    <CCol xl="6">
                                                        <div class="flexcontainer">
                                                            <div class="agentcus-grid">
                                                                <label class="switch" :style="renderStyle()">
                                                                    <!--<input type="checkbox" :checked="arry_OnOff.CBTU.CV" @change="v => arry_OnOff.CBTU.CV = v.target.checked">-->
                                                                    <input type="checkbox" :checked="arry_OnOff.CBTU.CV" @change="handleToggleChange('CBTU')">
                                                                    <span class="slider round"></span>
                                                                </label>
                                                                <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["CBTU"]}}</label>
                                                                <div class="custom_tooltip ACUZ_TT">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["CBTU"]}}</span>
                                                                </div>
                                                            </div>
                                                            <!-- Deposit Rate -->
                                                            <div v-if="arry_OnOff.CBTU.CV == true">
                                                                <div class="flex-item" style=" display: grid; grid-template-columns: 140px auto;">
                                                                    <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACU"]["RATE"]}}</label>
                                                                    <CInput class="inline inline30" :placeholder="getLanguage['ACU']['RATE']" size="sm" :value="arry_aac.Rate" @change="v => arry_aac.Rate = v"></CInput>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </CCol>

                                                    <!--=== Enable Bank Account in Numeric ==-->
                                                    <!--<CCol xl="6" class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">-->
                                                    <!--<input type="checkbox" :checked="arry_OnOff.EBAIN.CV" @change="v => arry_OnOff.EBAIN.CV = v.target.checked">-->
                                                    <!--<input type="checkbox" :checked="arry_OnOff.EBAIN.CV" @change="handleToggleChange('EBAIN')">
                                                        <span class="slider round"></span>
                                                    </label>
                                                    <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["BAIN"]}}</label>
                                                    <div class="custom_tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["BAIN"]}}</span>
                                                    </div>
                                                </CCol>-->
                                                    <!--=========== Member Bank Account Number Validation =========-->
                                                    <CCol xl="6">
                                                        <div class="flexcontainer">
                                                            <div class="agentcus-grid">
                                                                <label class="switch" :style="renderStyle()">
                                                                    <input type="checkbox" :checked="bool_EMBANS" @change="v=> bool_EMBANS = v.target.checked">
                                                                    <span class="slider round"></span>
                                                                </label>
                                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["EMBANS"]}}</label>
                                                                <div class="custom_tooltip ACUZ_TT">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["EMBANS"]}}</span>
                                                                </div>
                                                            </div>
                                                            <div v-if="bool_EMBANS">
                                                                <div class="flex-item agentcus-grid">
                                                                    <label class="switch">
                                                                        <input type="checkbox" :checked="arry_OnOff.MAANE.CV" @change="handleToggleChange('MAANE')">
                                                                        <span class="slider round"></span>
                                                                    </label>
                                                                    <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["AANE"]}}</label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["AANE"]}}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="flex-item agentcus-grid">
                                                                    <label class="switch">
                                                                        <input type="checkbox" :checked="arry_OnOff.MAEWAS.CV" @change="handleToggleChange('MAEWAS')">
                                                                        <span class="slider round"></span>
                                                                    </label>
                                                                    <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["AEWAS"]}}</label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["AEWAS"]}}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                    <!--=== Use Register Bank Account Name ==-->
                                                    <CCol xl="6" class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.RBAN.CV" @change="v => arry_OnOff.RBAN.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.RBAN.CV" @change="handleToggleChange('RBAN')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["RBAN"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["RBAN"]}}</span>
                                                        </div>
                                                    </CCol>

                                                    <CCol col="12" class="my-2">
                                                        <!--=== Back Office Setting ===-->
                                                        <p class="h6">
                                                            {{this.getLanguage["ACU"]["BOS"]}}
                                                        </p>
                                                        <div class='subHeaderHR'></div>
                                                    </CCol>

                                                    <CCol xl="6" class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.EPDN.CV" @change="v => arry_OnOff.EPDN.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.EPDN.CV" @change="handleToggleChange('EPDN')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["EPDN"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["EPDN"]}}</span>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.EPWN.CV" @change="v => arry_OnOff.EPWN.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.EPWN.CV" @change="handleToggleChange('EPWN')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["EPWN"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["EPWN"]}}</span>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.EPPN.CV" @change="v => arry_OnOff.EPPN.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.EPPN.CV" @change="handleToggleChange('EPPN')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["EPPN"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["EPPN"]}}</span>
                                                        </div>
                                                    </CCol>
                                                    <!--=== Company Account Details ==-->
                                                    <CCol xl="6" class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.CAD.CV" @change="v => arry_OnOff.CAD.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.CAD.CV" @change="handleToggleChange('CAD')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["CAD"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["CAD"]}}</span>
                                                        </div>
                                                    </CCol>
                                                    <!--=========== Bank Account Number Validation =========-->
                                                    <CCol xl="6">
                                                        <div class="flexcontainer">
                                                            <div class="agentcus-grid">
                                                                <label class="switch" :style="renderStyle()">
                                                                    <input type="checkbox" :checked="bool_EBANS" @change="v=> bool_EBANS = v.target.checked">
                                                                    <span class="slider round"></span>
                                                                </label>
                                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["EBANS"]}}</label>
                                                                <div class="custom_tooltip ACUZ_TT">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["EBANS"]}}</span>
                                                                </div>
                                                            </div>
                                                            <div v-if="bool_EBANS">
                                                                <div class="flex-item agentcus-grid">
                                                                    <label class="switch">
                                                                        <input type="checkbox" :checked="arry_OnOff.AANE.CV" @change="handleToggleChange('AANE')">
                                                                        <span class="slider round"></span>
                                                                    </label>
                                                                    <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["AANE"]}}</label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["AANE"]}}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="flex-item agentcus-grid">
                                                                    <label class="switch">
                                                                        <input type="checkbox" :checked="arry_OnOff.AEWAS.CV" @change="handleToggleChange('AEWAS')">
                                                                        <span class="slider round"></span>
                                                                    </label>
                                                                    <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["AEWAS"]}}</label>
                                                                    <div class="custom_tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["AEWAS"]}}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                </CRow>
                                            </CCard>
                                        </CCollapse>
                                        <!--BANK & BACK-OFFICE SETTING DIV END-->
                                        <!--CRYPTO SETTING DIV-->
                                        <CCollapse :show="agentconfig_CS">
                                            <CCard body-wrapper>
                                                <CRow>
                                                    <CCol col="12" class="mb-2">
                                                        <!--=== Crypto Setting ==-->
                                                        <p class="h6">
                                                            {{this.getLanguage["ACU"]["CS"]}}
                                                        </p>
                                                        <div class='subHeaderHR'></div>
                                                    </CCol>

                                                    <CCol xl="6" class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.ECF.CV" @change="v => arry_OnOff.ECF.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.ECF.CV" @change="handleToggleChange('ECF')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["ECF"]}}</label>
                                                        <div class="custom_tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["ECF"]}}</span>
                                                        </div>
                                                    </CCol>
                                                </CRow>
                                            </CCard>
                                        </CCollapse>
                                        <!--CRYPTO SETTING DIV END-->
                                    </div>
                                </div>
                                <div style="text-align:center;margin-top:20px" v-if="checkModuleAccess2(constAccessType.edit)">
                                    <CButton color="outline-info" size="sm" @click="saveAgentConfig()" v-if="!bool_isView">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}&nbsp;&nbsp;&nbsp;</label>
                                <label class="mandatory_Field" v-if="this.getUserInfo.AT == 0">{{this.getLanguage['ACU']['SAO']}}</label>
                            </CCardBody>

                        </CCard>
                    </div>
                </div>

            </transition>
        </div>

        <div v-if="bool_isAMVS">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:55%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["ACU"][arry_aac.I > 0? "EACF": "AACF"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeAddSimple()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <CRow>
                                    <CCol xl="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["MT"]["BN"]}}<span class="required" /> :</label>
                                        <customtreeselect :multiple="false"
                                                          :options="dd_agentgroupfs"
                                                          :flat="true"
                                                          :defaultExpandLevel="Infinity"
                                                          :clearable="false"
                                                          :placeholder="this.utilGetDDLanguage('DM.AGI')"
                                                          v-model="arry_aac['AGIT']"
                                                          :disabled="arry_aac.I > 0"
                                                          ref="AGIT" />
                                        <span class="ErrMsg">{{ ValidationErrMsg('AGIT','BN') }}</span>
                                    </CCol>
                                    <CCol xl="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["ACU"]["ST"]}} :</label>
                                        <treeselect :multiple="true"
                                                    :options="dd_acuz"
                                                    :limit="1"
                                                    :placeholder="this.utilGetDDLanguage('ACU.ST')"
                                                    :clearable="true"
                                                    v-model="arry_aac['nCuzView']" />
                                    </CCol>
                                </CRow>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveAgentConfig(true)">
                                        <span class='plusIcon cil-plus'></span>
                                        {{ this.getLanguage["BTN"]["SV"] }}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="previewImgUrl">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["GL"]["P"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="previewImgUrl = ''">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content text-center">
                                    <div class="text-right">
                                        <a class="btn btn-primary mb-3" href="https://afbgg.info/template.php" target="_blank" v-if="previewImgUrl.includes('-home.jpg')">{{this.getLanguage["DB"]["MORE"]}}</a>
                                    </div>
                                    <img :src="previewImgUrl" class="img-fluid" loading="lazy" :width="previewImgUrl.includes('SportOdd') ? 500 : 'auto'" />
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["ACU"]["ACF"]}}</h2>
                        <CButton size="sm" color="outline-info" v-if="checkModuleAccess2(constAccessType.add)" @click="addAgentConfig()"><span class='plusIcon cil-plus'></span>{{ this.getLanguage["BTN"]["AN"] }}</CButton>
                        <CButton size="sm" color="outline-info" v-if="checkModuleAccess2(constAccessType.add) && this.getUserInfo.AT == 0" @click="addAgentConfig(true)"><span class='plusIcon cil-plus'></span>{{ this.getLanguage["ACU"]["QA"] }}</CButton>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <label class="searchLabel">{{this.getLanguage["MT"]["BN"]}} :</label>
                                <customtreeselect :multiple="false"
                                                  :options="dd_agentgroupfs"
                                                  :flat="true"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="getLanguage['MT']['BN']"
                                                  @input="AgentGroupChangefs"
                                                  v-model="agit" />
                            </div>

                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" class='searchBtn' ref="search" size="sm" block color="success" @click="newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{this.getLanguage["ACU"]["ACFL"]}}</strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th style="width: 60px;">{{this.getLanguage["GL"]["NO"]}}</th>
                                <th style="width: 60px;" v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete) || checkModuleAccess2(constAccessType.view)">{{getLanguage["GL"]["ACT"]}}</th>
                                <th>{{this.getLanguage["MT"]["BN"]}}<i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["GL"]["CB"]}}</th>
                                <th>{{this.getLanguage["GL"]["CT"]}}<i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["GL"]["UB"]}}</th>
                                <th>{{this.getLanguage["GL"]["UTS"]}}<i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th style="width: 60px;">{{this.getLanguage["GL"]["NO"]}}</th>
                                <th style="width: 60px;" v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete) || checkModuleAccess2(constAccessType.view)">{{getLanguage["GL"]["ACT"]}}</th>
                                <th>{{this.getLanguage["MT"]["BN"]}}<i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["GL"]["CB"]}}</th>
                                <th>{{this.getLanguage["GL"]["CT"]}}<i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["GL"]["UB"]}}</th>
                                <th>{{this.getLanguage["GL"]["UTS"]}}<i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_acl.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arry_acl">
                            <td>{{ CountItem(index+1) }}</td>
                            <td v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete) || checkModuleAccess2(constAccessType.view)">
                                <span id="actionBtnCol">
                                    <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.delete) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <i class="cil-trash" style="margin-right: 0px" @click="removeAgentConfig(data)"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.delete) && (isSENS == 1 && data.AGI != curAGI)">
                                        <i class="cil-trash" style="margin-right: 0px"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <i class="cil-color-border" style="margin-left: 0px" @click="editAgentConfig(data.I)"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AGI != curAGI)">
                                        <i class="cil-color-border" style="margin-left: 0px"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                    <div v-if="checkModuleAccess2(constAccessType.view) && !checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class="custom_tooltip">
                                        <i class="cil-description" @click="viewAgentConfig(data.I)"></i> <!--here View -->
                                        <span class="tooltiptext">{{getLanguage["BTN"]["V"]}}</span>
                                    </div>
                                    <div v-if="checkModuleAccess2(constAccessType.view) && !checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AGI != curAGI)" class="custom_tooltip">
                                        <i class="cil-description"></i> <!--here View -->
                                        <span class="tooltiptext">{{getLanguage["BTN"]["V"]}}</span>
                                    </div>
                                    <!--new added-->
                                    <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <i class="fa fa-clone" @click='editAgentConfig(data.I,true)'></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["C"]}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AGI != curAGI)">
                                        <i class="fa fa-clone"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["C"]}}</span>
                                    </div>
                                </span>
                            </td>
                            <td>{{ data.GN }} ({{data.GPC}})</td>
                            <td>{{ data.CB }}</td>
                            <td>{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                            <td>{{ data.UB }}</td>
                            <td>{{ formatDateTime(data.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import DateRangePicker from 'vue2-daterange-picker'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import genericHelper from "@/modules/GenericHelper.js";
    import Loading from 'vue-loading-overlay';
    import { required, minLength, between, url, requiredIf } from 'vuelidate/lib/validators'
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js';
    import moment from "moment";
    import Vue from 'vue'
    Vue.config.devtools = true
    import $ from 'jquery'

    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            customtreeselect,
            Loading,
            DateRangePicker
        },
        props: {

        },
        data() {
            return {
                bool_cr: false, //customize register
                bool_CV: false, // Check Validation
                bool_isAMV: false, // Add Modal Visible
                bool_isAMVS: false, // Simple Add Modal Visible
                bool_fullLoading: false, // Add Modal Visible
                //sensBtn: true,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                bool_isView: false,
                ShowFullAgentConfig: false,
                int_RC: 100, //Row Count
                int_Page: 1,//current Page
                int_IC: 1, // Item Count
                int_TI: 0,//Total Items
                int_TP: 1, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true,
                str_FV: [{ F: "AGI" }], //Filter Value
                arry_aac: {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    nCuzView: null,
                    AGI: "",
                    AGIT: null,
                    E_CC: "",
                    E_PC: "",
                    LocalisedList: [],
                    InactiveDays: 365,
                    Rate: 0,
                    SOT: "",
                    TO: "",
                    DisabledProviderLobbies: []
                },
                arry_acl: [],
                dd_agentgroup: [],//agent group option
                dd_agentgroupfs: [],//agent group option
                dd_acuz: [],
                dd_gameprovider: [],
                searchAgent: null,
                constAccessType: constAccessType,
                arry_OnOff: {
                    "DGPL": { CV: false, DC: true },
                    "SL": { CV: true, DC: true },

                    //Captchas
                    "DCC": { CV: false, DC: true }, //Disable Captcha
                    "CCAOLN": { CV: false, DC: true }, //Alphabets Only
                    "CCALPN": { CV: false, DC: true }, //Alphanumeric
                    "CCNO": { CV: false, DC: true }, //Numeric Only
                    //

                    "RFWMP": { CV: false, DC: true },
                    "RWBA": { CV: true, DC: false },
                    "RWEA": { CV: false, DC: true },
                    "CDBACC": { CV: true, DC: true },
                    "CDPNO": { CV: true, DC: true },
                    "HMCI": { CV: false, DC: true },
                    "NADBABA": { CV: false, DC: false },
                    "DDB": { CV: false, DC: false },
                    "NADBA": { CV: false, DC: false },
                    "NAABA": { CV: false, DC: false },
                    "LMIAA": { CV: false, DC: false },
                    "NBRWD": { CV: false, DC: true },
                    "OWB": { CV: false, DC: false },
                    "SSMRB": { CV: false, DC: true },
                    "SHBAN": { CV: false, DC: true },
                    "HSCM": { CV: true, DC: false },
                    "HSQRCM": { CV: true, DC: false },
                    "HQRCBL": { CV: true, DC: false },
                    "HICSM": { CV: true, DC: false },
                    "SQRCSM": { CV: true, DC: true },
                    "RPN": { CV: false, DC: true },
                    "REGWPHONE": { CV: false, DC: true },
                    "HBLPU": { CV: true, DC: false },
                    "LD": { CV: false, DC: true },
                    "DADIF": { CV: false, DC: true },
                    "HMDO": { CV: false, DC: true },
                    "FNM": { CV: false, DC: true },
                    "FNABAN": { CV: false, DC: true },
                    "DWOTT": { CV: false, DC: true },
                    "ULPN": { CV: false, DC: true },
                    "UPCODE": { CV: false, DC: true },
                    "HCDIHO": { CV: true, DC: true },
                    "DWOTT": { CV: false, DC: true },
                    "DODDS": { CV: false, DC: true },
                    "DDNF": { CV: false, DC: false },
                    "MDMIA": { CV: false, DC: true },
                    "HMAN": { CV: false, DC: true },
                    "EAFBFHP": { CV: false, DC: true },
                    "DDLS": { CV: false, DC: true },
                    "SRC": { CV: false, DC: true },
                    "BABLBA": { CV: false, DC: true },
                    "ECF": { CV: false, DC: true }, //Crypto
                    "HATT": { CV: false, DC: true },
                    "EFPL": { CV: false, DC: true },
                    "FPDTMB": { CV: false, DC: true },
                    "FPDT": { CV: false, DC: true },
                    "FPMB": { CV: false, DC: true },
                    "ETBN": { CV: false, DC: true },
                    "DTMB": { CV: true, DC: false },
                    "DT": { CV: false, DC: true },
                    "MB": { CV: false, DC: true },
                    "PDO": { CV: false, DC: true },
                    "EFV": { CV: true, DC: false }, //enable full membersite version
                    "EUL": { CV: true, DC: false }, //Enable Userful Link
                    "MD": { CV: false, DC: true },
                    "AD": { CV: false, DC: true },
                    "ADP": { CV: false, DC: true },
                    "HP": { CV: false, DC: true },
                    "OP": { CV: false, DC: true },
                    "EZP": { CV: false, DC: true },
                    "TUP": { CV: false, DC: true },
                    "CT": { CV: false, DC: true },
                    "HATT": { CV: false, DC: true },
                    "SIPWM": { CV: true, DC: false },
                    "HMSB": { CV: false, DC: true },
                    "DSAB": { CV: false, DC: true },
                    "EASF": { CV: false, DC: true },
                    "CBTU": { CV: false, DC: true },
                    "AFTTFG": { CV: false, DC: true },
                    "HFTGBL": { CV: false, DC: true },
                    "HFTGAL": { CV: false, DC: true },
                    "DOTPV": { CV: false, DC: true },
                    "GLIF": { CV: true, DC: true },
                    "GLIFSW": { CV: false, DC: true },
                    "HT5DG": { CV: false, DC: true },
                    "HT5J": { CV: false, DC: true },
                    "HT5S": { CV: false, DC: true },
                    "HT5LC": { CV: false, DC: true },
                    "HT5SES": { CV: false, DC: true },
                    "XFU": { CV: false, DC: true },
                    "STP": { CV: false, DC: true },
                    "SUREP": { CV: false, DC: true },
                    "P918": { CV: false, DC: true },
                    "FUP": { CV: false, DC: true },
                    "TMONEY": { CV: false, DC: true },
                    "SMP": { CV: false, DC: true },
                    "U2P": { CV: false, DC: true },
                    "LP": { CV: false, DC: true },
                    "BCP": { CV: false, DC: true },
                    "FPG": { CV: false, DC: true },
                    "PGA": { CV: false, DC: true },
                    "AGP": { CV: false, DC: true },
                    "UP": { CV: false, DC: true },
                    "EUN": { CV: false, DC: true },
                    //"EBAIN": { CV: false, DC: true },
                    "RBAN": { CV: false, DC: true }, //Use Register Bank Account Name
                    "HL5GH": { CV: false, DC: true },
                    "HTR": { CV: false, DC: true },
                    "DMAL": { CV: false, DC: true },
                    "AANE": { CV: false, DC: true },
                    "AEWAS": { CV: false, DC: true },
                    "MAANE": { CV: false, DC: true },
                    "MAEWAS": { CV: false, DC: true },
                    "DMAR": { CV: false, DC: true },
                    "DMAD": { CV: false, DC: true },
                    "DMAW": { CV: false, DC: true },
                    "SM": { CV: false, DC: true },
                    //"PHONE": { CV: false, DC: true },
                    //"EMAIL": { CV: false, DC: true },
                    "WCID": { CV: false, DC: true },
                    "LID": { CV: false, DC: true },
                    "WAID": { CV: false, DC: true },
                    "TGID": { CV: false, DC: true },
                    "ZLID": { CV: false, DC: true },
                    "EPDN": { CV: false, DC: true },
                    "EPWN": { CV: false, DC: true },
                    "EPPN": { CV: false, DC: true },
                    "CAD": { CV: false, DC: true },
                    "PP": { CV: false, DC: true },
                    "DN": { CV: false, DC: true },
                    "EGPLL": { CV: false, DC: true },
                    "DLGFML": { CV: false, DC: true },
                    "OKP": { CV: false, DC: true },
                    "MGP": { CV: false, DC: true },
                    "VIP": { CV: false, DC: true },
                    "AFP": { CV: false, DC: true },
                    "ONEP": { CV: false, DC: true },
                    "BLEUP": { CV: false, DC: true },
                    "E88P": { CV: false, DC: true },
                    "PPYP": { CV: false, DC: true },
                    "ECP": { CV: false, DC: true },
                    "ZPAY": { CV: false, DC: true },
                    "UPAY": { CV: false, DC: true },
                    "DGPCNY": { CV: false, DC: true },
                    "SUPER7VND": { CV: false, DC: true },
                    "PAYNGO": { CV: false, DC: true },
                    "PAYPRO": { CV: false, DC: true },
                    "PAYLITE": { CV: false, DC: true },
                    "HUIJUCAI": { CV: false, DC: true },
                    "BestPay": { CV: false, DC: true },
                    "CLOUDPAY": { CV: false, DC: true },
                    "LNWPAY": { CV: false, DC: true },

                },
                obj_LCC: {
                    CC: "",
                    PC: "",
                    LZ: 0,
                    PN: ""
                },
                depositOptions: [
                    { key: 'MD', value: 'MD', languageKey: 'MD' },
                    { key: 'AD', value: 'AD', languageKey: 'AD' },
                    { key: 'ADP', value: 'ADP', languageKey: 'ADP' },
                    { key: 'HP', value: 'HP', languageKey: 'HP' },
                    { key: 'OP', value: 'OP', languageKey: 'OP' },
                    { key: 'EZP', value: 'EZP', languageKey: 'EZP' },
                    { key: 'TUP', value: 'TUP', languageKey: 'TUP' },
                    { key: 'CT', value: 'CT', languageKey: 'CT' },
                    { key: 'XFU', value: 'XFU', languageKey: 'XFU' },
                    { key: 'STP', value: 'STP', languageKey: 'STP' },
                    { key: 'SUREP', value: 'SUREP', languageKey: 'SUREP' },
                    { key: 'P918', value: 'P918', languageKey: '918P' },
                    { key: 'FUP', value: 'FUP', languageKey: 'FUP' },
                    { key: 'TMONEY', value: 'TMONEY', languageKey: 'TMONEY' },
                    { key: 'SMP', value: 'SMP', languageKey: 'SMP' },
                    { key: 'U2P', value: 'U2P', languageKey: 'U2P' },
                    { key: 'LP', value: 'LP', languageKey: 'LP' },
                    { key: 'BCP', value: 'BCP', languageKey: 'BCP' },
                    { key: 'FPG', value: 'FPG', languageKey: 'FPG' },
                    { key: 'PGA', value: 'PGA', languageKey: 'PGA' },
                    { key: 'PP', value: 'PP', languageKey: 'PP' },
                    { key: 'DN', value: 'DN', languageKey: 'DN' },
                    { key: 'AGP', value: 'AGP', languageKey: 'AGP' },
                    { key: 'UP', value: 'UP', languageKey: 'UP' },
                    { key: 'OKP', value: 'OKP', languageKey: 'OKP' },
                    { key: 'MGP', value: 'MGP', languageKey: 'MGP' },
                    { key: 'VIP', value: 'VIP', languageKey: 'VIP' },
                    { key: 'AFP', value: 'AFP', languageKey: 'AFP' },
                    { key: 'ONEP', value: 'ONEP', languageKey: 'ONEP' },
                    { key: 'BLEUP', value: 'BLEUP', languageKey: 'BLEUP' },
                    { key: 'E88P', value: 'E88P', languageKey: 'E88P' },
                    { key: 'PPYP', value: 'PPYP', languageKey: 'PPYP' },
                    { key: 'ECP', value: 'ECP', languageKey: 'ECP' },
                    { key: 'ZPAY', value: 'ZPAY', languageKey: 'ZPAY' },
                    { key: 'UPAY', value: 'UPAY', languageKey: 'UPAY' },
                    { key: 'DGPCNY', value: 'DGPCNY', languageKey: 'DGPCNY' },
                    { key: 'SUPER7VND', value: 'SUPER7VND', languageKey: 'SUPER7VND' },
                    { key: 'PAYNGO', value: 'PAYNGO', languageKey: 'PAYNGO' },
                    { key: 'PAYPRO', value: 'PAYPRO', languageKey: 'PAYPRO' },
                    { key: 'PAYLITE', value: 'PAYLITE', languageKey: 'PAYLITE' },
                    { key: 'HUIJUCAI', value: 'HUIJUCAI', languageKey: 'HUIJUCAI' },
                    { key: 'BestPay', value: 'BestPay', languageKey: 'BestPay' },
                    { key: 'CLOUDPAY', value: 'CLOUDPAY', languageKey: 'CLOUDPAY' },
                    { key: 'LNWPAY', value: 'LNWPAY', languageKey: 'LNWPAY' },

                ],
                captchaOptions: [
                    { value: 'CCAOLN', languageKey: 'AOLN' },
                    { value: 'CCALPN', languageKey: 'CCALPN' },
                    { value: 'CCNO', languageKey: 'CCNO' },
                    { value: 'DCC', languageKey: 'DCC' }
                ],
                /*arry_Localised: [],*/
                str_CaptchaOption: "",
                str_PreferredDepositOption: "",
                str_TournamentNavOption: "",
                str_ForgotPasswordLinkOption: "",
                bool_DMSA: false,
                bool_EBANS: false,
                bool_EMBANS: false,
                bool_HFLQRC: false,
                agit: null,
                agentconfig_LS: true,
                agentconfig_RS: false,
                agentconfig_MSS: false,
                agentconfig_BBOS: false,
                agentconfig_CS: false,

                previewImgUrl: null,
                selectedSOTValue: 'HDP',
                selectedTOValue: 'D',
                sportOddsTypeOptions: [
                    { id: 'HDP', label: 'HDP' },
                    { id: 'OU', label: 'OU' },
                    { id: 'X12', label: '1X2' }
                ],
                allThemeOptions: {
                    'HDP': [{ id: 'D', label: 'Default' }, { id: 'Black', label: 'Black' }, { id: 'Blue', label: 'Blue' }, { id: 'DarkBlue', label: 'DarkBlue' }, { id: 'Silver', label: 'Silver' }, { id: 'BgPlayer', label: 'BgPlayer' }, { id: 'BgKickBall', label: 'BgKickBall' }, { id: 'BgCardRedPurple', label: 'BgCardRedPurple' }, { id: 'BgCardPurple', label: 'BgCardPurple' }, { id: 'BgCardGreen', label: 'BgCardGreen' }, { id: 'BgCardGold', label: 'BgCardGold' }, { id: 'BgCardSkyBlue', label: 'BgCardSkyBlue' }, { id: 'BgCardBlue', label: 'BgCardBlue' }, { id: 'BgCardDarkBlue', label: 'BgCardDarkBlue' }],
                    'OU': [{ id: 'D', label: 'Default' }, { id: 'Black', label: 'Black' }, { id: 'Blue', label: 'Blue' }, { id: 'DarkBlue', label: 'DarkBlue' }, { id: 'Silver', label: 'Silver' }, { id: 'BgCardRedPurple', label: 'BgCardRedPurple' }, { id: 'BgCardPurple', label: 'BgCardPurple' }, { id: 'BgCardGreen', label: 'BgCardGreen' }, { id: 'BgCardGold', label: 'BgCardGold' }, { id: 'BgCardSkyBlue', label: 'BgCardSkyBlue' }, { id: 'BgCardBlue', label: 'BgCardBlue' }, { id: 'BgCardDarkBlue', label: 'BgCardDarkBlue' }],
                    'X12': [{ id: 'Blue', label: 'Blue' }, { id: 'Silver', label: 'Silver' }, { id: 'BgKickBall', label: 'BgKickBall' }, { id: 'BgGoalBall', label: 'BgGoalBall' }]
                },
            }
        },
        validations: {
            arry_aac: {
                AGIT: { required },
            },
        },
        created() {
            if (this.$route.path == '/AGS/ACUZ') {
                this.$parent.showSubMenu = 'AGS';
                this.$parent.showActiveMenu = 'AGS.ACUZ';
            } else if (this.$route.path == '/WEBS/ACUZ') {
                this.$parent.showSubMenu = 'WEBS';
                this.$parent.showActiveMenu = 'WEBS.ACUZ';
            }
            var parameters = this.$route.query;
            if (parameters.agi !== undefined) {
                this.agit = parameters.agi;
                this.str_FV[0].FV = parameters.agi.split("-")[1]
            }
            this.getAgentGroup();
            this.getACList();
            this.getAgentSettingValue();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
            this.ShowFullAgentConfig = !this.getUserInfo.IHAC;
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
            filteredThemeOptions() {
                return this.allThemeOptions[this.selectedSOTValue] || [];
            }
        },
        methods: {
            ...mapActions('UserInfo', ['setUser']),
            onDisableGameProviderLobbiessChanged(event) {
                var that = this;
                that.arry_OnOff.DGPL.CV = event.target.checked;
                if (that.dd_gameprovider.length === 0 && event.target.checked) {
                    if (that.arry_aac.AGI > 0) {
                        this.getGameProviders(that.arry_aac.AGI);
                    } else {
                        that.dd_gameprovider = [];
                    }
                }
            },
            //Used for most toggle to easily maintain
            //Turn true to false and vice versa
            handleToggleChange(key) {
                if (this.arry_OnOff[key]) {
                    this.arry_OnOff[key].CV = !this.arry_OnOff[key].CV;
                }
            },
            getGameProviders(agi) {
                var that = this;
                this.getDataApi(`/api/dd/inactivatable-provider-lobbies/${agi}`,
                    function (d, s) {
                        if (s) {
                            that.dd_gameprovider = d.dropdownlist;
                        }
                    });
            },
            tickLeadinZero(event, data, type, row) {
                var that = this;
                var index = row - 1;

                for (var i = 0; i < that.arry_aac.LocalisedList.length; i++) {
                    if (i == index) {
                        if (type > 0) {
                            that.arry_aac.LocalisedList[i].LZ = 0;
                            var w_lz = that.arry_aac.LocalisedList[i].PC.substr(1);
                            that.arry_aac.LocalisedList[i].PN = that.arry_aac.LocalisedList[i].CC + '' + w_lz;
                        } else {
                            that.arry_aac.LocalisedList[i].LZ = 1;
                            that.arry_aac.LocalisedList[i].PN = that.arry_aac.LocalisedList[i].CC + '' + that.arry_aac.LocalisedList[i].PC;
                        }
                    }
                }
            },
            getPreset(data) {
                var w_lz = data.PC.substr(1);

                if (data.LZ > 0) {
                    return data.CC + '' + data.PC;
                } else {
                    return data.CC + '' + w_lz;
                }
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('ACUZ', 'AGS', type);
            },
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_CV = false;
                this.bool_isView = false;
            },
            closeAddSimple() {
                this.bool_isAMVS = !this.bool_isAMVS;
                this.bool_CV = false;
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getACList();
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getACList();
                }
            },
            getAgentSettingValue() {
                var that = this;
                this.getDataApi(`/api/dd/acuz/`,
                    function (d, s) {
                        if (s) {
                            that.dd_acuz = d.dropdownlist;


                        }
                    });
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {

                            that.dd_agentgroupfs = that.deepClone(d.dropdownlist);

                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.getUserInfo.ISENS == 1) {
                                that.dd_agentgroup = that.dd_agentgroup.filter(f => f.id == "3-" + that.getUserInfo.AGI);
                            }

                            //if (that.dd_agentgroup.length > 0) {
                            //    that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            //}
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            AgentGroupChangefs(value) {
                if (value == "" || value == null || value == undefined) {
                    this.str_FV[0].FV = null;

                }
                else {
                    this.str_FV[0].FV = value.split("-")[1];
                }
            },
            getACList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV) {
                        if (path) {
                            path += "&";
                        }
                        if (this.str_FV[i].FA && this.str_FV[i].FV) {
                            var temp_ = "";
                            for (var x = 0; x < this.str_FV[i].FV.length; x++) {
                                if (x != 0) {
                                    temp_ += ",";
                                }
                                temp_ += this.str_FV[i].FV[x];
                            }
                            path += ("f[" + this.str_FV[i].F + "]=" + temp_);
                        }
                        else {
                            path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                        }
                    }
                };

                path += ("&f[RS]=2");

                this.getDataApi(`/api/acuz/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setACList(d.D);
                            that.resizeTableHead();
                        }
                    });
            },
            setACList(data) {
                this.arry_acl = data.Items;
                this.int_TP = Math.max(data.TotalPages, 1);                
                this.int_TI = data.TotalItems;
            },
            setAC(data) {
                //Get AgentCustomize Record
                this.arry_aac = data;
                this.arry_aac.nCuzView = [];
                this.bool_DMSA = false;
                this.bool_EBANS = false;
                this.bool_EMBANS = false;
                this.bool_HFLQRC = false;
                for (var x = 0; x < data.CuzView.length; x++) {
                    this.arry_aac.nCuzView.push(data.CuzView[x].CC);
                }

                if (data.LocalisedList.length > 0) {
                    this.arry_aac.E_CC = data.LocalisedList[0].CC;
                    this.arry_aac.E_PC = "";
                } else {
                    this.arry_OnOff.UPCODE.CV = false;
                    this.arry_aac.E_CC = "";
                    this.arry_aac.E_PC = "";
                }
                this.arry_OnOff = {
                   "DGPL": { CV: false, DC: true },
                   "SL": { CV: false, DC: true },

                   //Captchas
                   "DCC": { CV: false, DC: true }, //Disable Captcha
                   "CCAOLN": { CV: false, DC: true }, //Alphabets Only
                   "CCALPN": { CV: false, DC: true }, //Alphanumeric
                   "CCNO": { CV: false, DC: true }, //Numeric Only
                   //

                   "RFWMP": { CV: false, DC: true },
                   "RWBA": { CV: false, DC: false },
                   "RWEA": { CV: false, DC: true },
                   "CDBACC": { CV: false, DC: true },
                   "CDPNO": { CV: false, DC: true },
                   "HMCI": { CV: false, DC: true },
                   "NADBABA": { CV: false, DC: false },
                   "DDB": { CV: false, DC: false },
                   "NADBA": { CV: false, DC: false },
                   "NAABA": { CV: false, DC: false },
                   "LMIAA": { CV: false, DC: false },
                   "NBRWD": { CV: false, DC: true },
                   "OWB": { CV: false, DC: false },
                   "SSMRB": { CV: false, DC: true },
                   "SHBAN": { CV: false, DC: true },
                   "HSCM": { CV: false, DC: false },
                   "HSQRCM": { CV: false, DC: false },
                   "HQRCBL": { CV: false, DC: false },
                   "HICSM": { CV: false, DC: false },
                   "SQRCSM": { CV: false, DC: true },
                   "RPN": { CV: false, DC: true },
                   "REGWPHONE": { CV: false, DC: true },
                   "HBLPU": { CV: false, DC: false },
                   "LD": { CV: false, DC: true },
                   "DADIF": { CV: false, DC: true },
                   "HMDO": { CV: false, DC: true },
                   "FNM": { CV: false, DC: true },
                   "FNABAN": { CV: false, DC: true },
                   "DWOTT": { CV: false, DC: true },
                   "ULPN": { CV: false, DC: true },
                   "UPCODE": { CV: false, DC: true },
                   "HCDIHO": { CV: false, DC: true },   // Hide Currency Dropdown If Having Only One Option
                   "DWOTT": { CV: false, DC: true },
                   "DODDS": { CV: false, DC: true },
                   "DDNF": { CV: false, DC: false },
                   "MDMIA": { CV: false, DC: true },
                   "HMAN": { CV: false, DC: true },
                   "EAFBFHP": { CV: false, DC: true },
                   "DDLS": { CV: false, DC: true },
                   "SRC": { CV: false, DC: true },
                   "BABLBA": { CV: false, DC: true },
                   "ECF": { CV: false, DC: true }, //Crypto
                   "HATT": { CV: false, DC: true },
                   "EFPL": { CV: false, DC: true },
                   "FPDTMB": { CV: true, DC: true },
                   "FPDT": { CV: false, DC: true },
                   "FPMB": { CV: false, DC: true },
                   "ETBN": { CV: false, DC: true },
                   "DTMB": { CV: true, DC: true },
                   "DT": { CV: false, DC: true },
                   "MB": { CV: false, DC: true },
                   "EFV": { CV: false, DC: false }, // enable full membersite version
                   "EUL": { CV: false, DC: false }, 
                   "PDO": { CV: false, DC: true },
                   "MD": { CV: false, DC: true },
                   "AD": { CV: false, DC: true },
                   "ADP": { CV: false, DC: true },
                   "HP": { CV: false, DC: true },
                   "OP": { CV: false, DC: true },
                   "EZP": { CV: false, DC: true },
                   "TUP": { CV: false, DC: true },
                   "CT": { CV: false, DC: true },
                   "HATT": { CV: false, DC: true },
                   "SIPWM": { CV: false, DC: false },  // Show Invalid Phone Waring Message
                   "HMSB": { CV: false, DC: true },
                   "DSAB": { CV: false, DC: true },
                   "EASF": { CV: false, DC: true },
                   "CBTU": { CV: false, DC: true },
                   "AFTTFG": { CV: false, DC: true },
                   "HFTGBL": { CV: false, DC: true },
                   "HFTGAL": { CV: false, DC: true },
                   "DOTPV": { CV: false, DC: true },
                   "GLIF": { CV: false, DC: true },
                   "GLIFSW": { CV: false, DC: true },
                   "HT5DG": { CV: false, DC: true },
                   "HT5J": { CV: false, DC: true },
                   "HT5S": { CV: false, DC: true },
                   "HT5LC": { CV: false, DC: true },
                   "HT5SES": { CV: false, DC: true },
                   "XFU": { CV: false, DC: true },
                   "STP": { CV: false, DC: true },
                   "SUREP": { CV: false, DC: true },
                   "P918": { CV: false, DC: true },
                   "FUP": { CV: false, DC: true },
                   "TMONEY": { CV: false, DC: true },
                   "SMP": { CV: false, DC: true },
                   "U2P": { CV: false, DC: true },
                   "LP": { CV: false, DC: true },
                   "BCP": { CV: false, DC: true },
                   "FPG": { CV: false, DC: true },
                   "PGA": { CV: false, DC: true },
                   "AGP": { CV: false, DC: true },
                   "UP": { CV: false, DC: true },
                   "EUN": { CV: false, DC: true },
                   //"EBAIN": { CV: false, DC: true },
                   "RBAN": { CV: false, DC: true },
                   "HL5GH": { CV: false, DC: true },
                   "HTR": { CV: false, DC: true },
                   "DMAL": { CV: false, DC: true },
                   "AANE": { CV: false, DC: true },
                    "AEWAS": { CV: false, DC: true },
                    "MAANE": { CV: false, DC: true },
                    "MAEWAS": { CV: false, DC: true },
                   "DMAR": { CV: false, DC: true },
                   "DMAD": { CV: false, DC: true },
                   "DMAW": { CV: false, DC: true },
                   "SM": { CV: false, DC: true },
                   //"PHONE": { CV: false, DC: true },
                   //"EMAIL": { CV: false, DC: true },
                   "WCID": { CV: false, DC: true },
                   "LID": { CV: false, DC: true },
                   "WAID": { CV: false, DC: true },
                   "TGID": { CV: false, DC: true },
                   "ZLID": { CV: false, DC: true },
                   "EPDN": { CV: false, DC: true },
                   "EPWN": { CV: false, DC: true },
                   "EPPN": { CV: false, DC: true },
                   "CAD": { CV: false, DC: true },
                   "PP": { CV: false, DC: true },
                   "DN": { CV: false, DC: true },
                   "EGPLL": { CV: false, DC: true },
                   "DLGFML": { CV: false, DC: true },
                   "OKP": { CV: false, DC: true },
                   "MGP": { CV: false, DC: true },
                    "VIP": { CV: false, DC: true },
                    "AFP": { CV: false, DC: true },
                    "ONEP": { CV: false, DC: true },
                    "BLEUP": { CV: false, DC: true },
                    "E88P": { CV: false, DC: true },
                    "PPYP": { CV: false, DC: true },
                    "ECP": { CV: false, DC: true },
                    "ZPAY": { CV: false, DC: true },
                    "UPAY": { CV: false, DC: true },
                    "DGPCNY": { CV: false, DC: true },
                    "SUPER7VND": { CV: false, DC: true },
                    "PAYNGO": { CV: false, DC: true }, 
                    "PAYPRO": { CV: false, DC: true },
                    "PAYLITE": { CV: false, DC: true }, 
                    "HUIJUCAI": { CV: false, DC: true }, 
                    "BestPay": { CV: false, DC: true },
                    "CLOUDPAY": { CV: false, DC: true },
                    "LNWPAY": { CV: false, DC: true },
                };

                //default value cv == true
                // if false then save to db = false

                for (const [key, value] of Object.entries(this.arry_OnOff)) {
                    //if (value.DC) {
                    //    if (this.arry_aac.nCuzView.includes(key)) {
                    //        value.CV = true;
                    //        if (key == "CCAOLN" || key == "CCALPN" || key == "CCNO" || key == "DCC") {
                    //            this.str_CaptchaOption = key;
                    //        }
                    //        else if (key == "MD" || key == "AD" || key == "ADP" || key == "HP" || key == "OP" || key == "EZP" || key == "TUP" || key == "CT" || key == "XFU") {
                    //            //debugger;
                    //            this.str_PreferredDepositOption = key;
                    //        }
                    //        else if (key == "DTMB" || key == "DT" || key == "MB") {
                    //            this.str_TournamentNavOption = key;
                    //        }
                    //        else if (key == "FPDTMB" || key == "FPDT" || key == "FPMB") {
                    //            this.str_ForgotPasswordLinkOption = key;
                    //        }
                    //        else if (key == "DGPL") {
                    //            this.getGameProviders(data.AGI)
                    //        }
                    //    }
                    //}
                    //else {
                    //    if (!this.arry_aac.nCuzView.includes(key)) {
                    //        value.CV = true;
                    //    }
                    //}

                    if (value.DC) { //if value is true 
                        if (this.arry_aac.nCuzView.includes(key)) {

                            value.CV = true;

                            switch (key) {
                                case "CCAOLN":
                                case "CCALPN":
                                case "CCNO":
                                case "DCC":
                                    this.str_CaptchaOption = key;
                                    break;

                                case "MD":
                                case "AD":
                                case "ADP":
                                case "HP":
                                case "OP":
                                case "EZP":
                                case "TUP":
                                case "CT":
                                case "XFU":
                                case "STP":
                                case "SUREP":
                                case "P918":
                                case "FUP":
                                case "TMONEY":
                                case "SMP":
                                case "U2P":
                                case "LP":
                                case "BCP":
                                case "FPG":
                                case "PGA":
                                case "PP":
                                case "DN":
                                case "AGP":
                                case "UP":
                                case "OKP":
                                case "MGP":
                                case "VIP":
                                case "AFP":
                                case "ONEP":
                                case "BLEUP":
                                case "E88P":
                                case "PPYP":
                                case "ECP":
                                case "ZPAY":
                                case "UPAY":
                                case "DGPCNY":
                                case "SUPER7VND":
                                case "PAYNGO":
                                case "PAYPRO":
                                case "PAYLITE":
                                case "HUIJUCAI":
                                case "BestPay":
                                case "CLOUDPAY":
                                case "LNWPAY":
                                    this.str_PreferredDepositOption = key;
                                    break;

                                case "DTMB":
                                case "DT":
                                case "MB":
                                    this.str_TournamentNavOption = key;
                                    break;

                                case "FPDTMB":
                                case "FPDT":
                                case "FPMB":
                                    this.str_ForgotPasswordLinkOption = key;
                                    break;

                                case "DGPL":
                                    this.getGameProviders(data.AGI);
                                    break;

                                default:
                                    break;
                            }
                        }
                    } else {
                        if (!this.arry_aac.nCuzView.includes(key)) {
                            value.CV = true;
                        }
                    }
                }

                //Default it to "Disable Captcha" if empty
                if (this.str_CaptchaOption == null || this.str_CaptchaOption == "") {
                    this.str_CaptchaOption = "DCC";
                }

                this.selectedSOTValue = this.arry_aac.SportOddsType ? this.arry_aac.SportOddsType : 'HDP';
                this.selectedTOValue = this.arry_aac.ThemeOption ? this.arry_aac.ThemeOption : 'D';

                if (this.arry_aac.InactiveDays == -1) {
                    this.arry_aac.InactiveDays = 365;
                }
                if (this.arry_OnOff.DMAL.CV || this.arry_OnOff.DMAR.CV || this.arry_OnOff.DMAD.CV || this.arry_OnOff.DMAW.CV) {
                    this.bool_DMSA = true;
                }

                if (this.arry_OnOff.AANE.CV || this.arry_OnOff.AEWAS.CV) {
                    this.bool_EBANS = true;
                }

                if (this.arry_OnOff.MAANE.CV || this.arry_OnOff.MAEWAS.CV) {
                    this.bool_EMBANS = true;
                }

                if (this.arry_OnOff.HQRCBL.CV || this.arry_OnOff.HSQRCM.CV) {
                    this.bool_HFLQRC = true;
                }
                this.bool_isAMV = true;
            },

            addAgentConfig(isSimple = false) {
                this.showAgentConfig(1);
                this.arry_aac = {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    nCuzView: null,
                    AGI: "",
                    AGIT: null,
                    E_CC: "",
                    E_PC: "",
                    LocalisedList: [],
                    InactiveDays: 365,
                    Rate: 0,
                    SOT: "",
                    TO: "",
                    DisabledProviderLobbies: []
                };

                this.dd_gameprovider = [];

                this.arry_OnOff = {
                    "DGPL": { CV: false, DC: true },
                    "SL": { CV: true, DC: true },

                    //Captchas
                    "DCC": { CV: false, DC: true }, //Disable Captcha
                    "CCAOLN": { CV: false, DC: true }, //Alphabets Only
                    "CCALPN": { CV: false, DC: true }, //Alphanumeric
                    "CCNO": { CV: false, DC: true }, //Numeric Only
                    //

                    "RFWMP": { CV: false, DC: true },
                    "RWBA": { CV: true, DC: false },
                    "RWEA": { CV: false, DC: true },
                    "CDBACC": { CV: true, DC: true },
                    "CDPNO": { CV: true, DC: true },
                    "HMCI": { CV: false, DC: true },
                    "NADBABA": { CV: false, DC: false },
                    "DDB": { CV: false, DC: false },
                    "NADBA": { CV: false, DC: false },
                    "NAABA": { CV: false, DC: false },
                    "LMIAA": { CV: false, DC: false },
                    "NBRWD": { CV: false, DC: true },
                    "OWB": { CV: false, DC: false },
                    "SSMRB": { CV: false, DC: true },
                    "SHBAN": { CV: false, DC: true },
                    "HSCM": { CV: true, DC: false },
                    "HSQRCM": { CV: true, DC: false },
                    "HQRCBL": { CV: true, DC: false },
                    "HICSM": { CV: true, DC: false },
                    "SQRCSM": { CV: true, DC: true },
                    "RPN": { CV: false, DC: true },
                    "REGWPHONE": { CV: false, DC: true },
                    "HBLPU": { CV: true, DC: false },
                    "LD": { CV: false, DC: true },
                    "DADIF": { CV: false, DC: true },
                    "HMDO": { CV: false, DC: true },
                    "FNM": { CV: false, DC: true },
                    "FNABAN": { CV: false, DC: true },
                    "DWOTT": { CV: false, DC: true },
                    "ULPN": { CV: false, DC: true },
                    "UPCODE": { CV: false, DC: true },
                    "HCDIHO": { CV: true, DC: true },
                    "DWOTT": { CV: false, DC: true },
                    "DODDS": { CV: false, DC: true },
                    "DDNF": { CV: false, DC: false },
                    "MDMIA": { CV: false, DC: true },
                    "HMAN": { CV: false, DC: true },
                    "EAFBFHP": { CV: false, DC: true },
                    "DDLS": { CV: false, DC: true },
                    "SRC": { CV: false, DC: true },
                    "BABLBA": { CV: false, DC: true },
                    "ECF": { CV: false, DC: true }, //Crypto
                    "HATT": { CV: false, DC: true },
                    "EFPL": { CV: true, DC: true },
                    "FPDTMB": { CV: true, DC: false },
                    "FPDT": { CV: false, DC: true },
                    "FPMB": { CV: false, DC: true },
                    "ETBN": { CV: true, DC: true },
                    "DTMB": { CV: true, DC: false },
                    "EFV": { CV: true, DC: false }, //enable full membersite version
                    "EUL": { CV: true, DC: false },
                    "DT": { CV: false, DC: true },
                    "MB": { CV: false, DC: true },
                    "PDO": { CV: false, DC: true },
                    "MD": { CV: true, DC: false },
                    "AD": { CV: false, DC: true },
                    "ADP": { CV: false, DC: true },
                    "HP": { CV: false, DC: true },
                    "OP": { CV: false, DC: true },
                    "EZP": { CV: false, DC: true },
                    "TUP": { CV: false, DC: true },
                    "CT": { CV: false, DC: true },
                    "HATT": { CV: false, DC: true },
                    "SIPWM": { CV: true, DC: false },
                    "HMSB": { CV: false, DC: true },
                    "DSAB": { CV: false, DC: true },
                    "EASF": { CV: false, DC: true },
                    "CBTU": { CV: false, DC: true },
                    "AFTTFG": { CV: false, DC: true },
                    "HFTGBL": { CV: false, DC: true },
                    "HFTGAL": { CV: false, DC: true },
                    "DOTPV": { CV: false, DC: true },
                    "GLIF": { CV: true, DC: true },
                    "GLIFSW": { CV: false, DC: true },
                    "HT5DG": { CV: false, DC: true },
                    "HT5J": { CV: false, DC: true },
                    "HT5S": { CV: false, DC: true },
                    "HT5LC": { CV: false, DC: true },
                    "HT5SES": { CV: false, DC: true },
                    "XFU": { CV: false, DC: true },
                    "STP": { CV: false, DC: true },
                    "SUREP": { CV: false, DC: true },
                    "P918": { CV: false, DC: true },
                    "FUP": { CV: false, DC: true },
                    "TMONEY": { CV: false, DC: true },
                    "SMP": { CV: false, DC: true },
                    "U2P": { CV: false, DC: true },
                    "LP": { CV: false, DC: true },
                    "BCP": { CV: false, DC: true },
                    "FPG": { CV: false, DC: true },
                    "PGA": { CV: false, DC: true },
                    "AGP": { CV: false, DC: true },
                    "UP": { CV: false, DC: true },
                    "EUN": { CV: false, DC: true },
                    //"EBAIN": { CV: false, DC: true },
                    "RBAN": { CV: false, DC: true },
                    "HL5GH": { CV: false, DC: true },
                    "HTR": { CV: false, DC: true },
                    "DMAL": { CV: false, DC: true },
                    "DMAR": { CV: false, DC: true },
                    "DMAD": { CV: false, DC: true },
                    "DMAW": { CV: false, DC: true },
                    "SM": { CV: false, DC: true },
                    //"PHONE": { CV: false, DC: true },
                    //"EMAIL": { CV: false, DC: true },
                    "WCID": { CV: false, DC: true },
                    "LID": { CV: false, DC: true },
                    "WAID": { CV: false, DC: true },
                    "TGID": { CV: false, DC: true },
                    "ZLID": { CV: false, DC: true },
                    "EPDN": { CV: false, DC: true },
                    "EPWN": { CV: false, DC: true },
                    "EPPN": { CV: false, DC: true },
                    "CAD": { CV: false, DC: true },
                    "PP": { CV: false, DC: true },
                    "DN": { CV: false, DC: true },
                    "EGPLL": { CV: false, DC: true },
                    "DLGFML": { CV: false, DC: true },
                    "OKP": { CV: false, DC: true },
                    "MGP": { CV: false, DC: true },
                    "VIP": { CV: false, DC: true },
                    "AFP": { CV: false, DC: true },
                    "ONEP": { CV: false, DC: true },
                    "BLEUP": { CV: false, DC: true },
                    "E88P": { CV: false, DC: true },
                    "PPYP": { CV: false, DC: true },
                    "ECP": { CV: false, DC: true },
                    "ZPAY": { CV: false, DC: true },
                    "UPAY": { CV: false, DC: true },
                    "DGPCNY": { CV: false, DC: true },
                    "SUPER7VND": { CV: false, DC: true },
                    "PAYNGO": { CV: false, DC: true },
                    "PAYPRO": { CV: false, DC: true },
                    "PAYLITE": { CV: false, DC: true },
                    "HUIJUCAI": { CV: false, DC: true },
                    "BestPay": { CV: false, DC: true },
                    "CLOUDPAY": { CV: false, DC: true },
                    "LNWPAY": { CV: false, DC: true },
                };

                this.obj_LCC = {
                    CC: "",
                    PC: "",
                    LZ: 0,
                    PN: ""
                };

                this.arry_aac.nCuzView = [];
                if (isSimple) {
                    this.bool_isAMVS = true;
                    this.bool_CV = false;
                }
                else {
                    this.bool_isAMV = true;
                    this.bool_CV = false;
                }

                if (this.dd_agentgroup[0].children == undefined) {
                    var at = 0;
                    at = this.dd_agentgroup[0].id.split("-")[0];
                    if (at == 3 && this.dd_agentgroup.length < 2) {
                        this.arry_aac.AGIT = this.dd_agentgroup[0].id;
                    }
                }
                this.bool_DMSA = false;
                this.bool_EBANS = false;
                this.bool_EMBANS = false;
                this.bool_HFLQRC = true;
                this.searchAgent = null;

                //Default Setting for Captcha
                if (this.str_CaptchaOption == null || this.str_CaptchaOption == "") {
                    this.str_CaptchaOption = "DCC";
                }

                //Default Setting for Enable Forgot Password Link
                if (this.arry_OnOff["EFPL"].CV == true && (this.str_ForgotPasswordLinkOption == null || this.str_ForgotPasswordLinkOption == "")) {
                    this.str_ForgotPasswordLinkOption = "FPDTMB";
                }

            },
            ValidationErrMsg(value, langKey = "") {
                if (this.bool_CV) {
                    var validateObj = this.$v.arry_aac[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MT"][langKey]);
                    }
                }

            },
            saveAgentConfig(isSimple = false) {
                if (this.bool_EBANS) {
                    if (!this.arry_OnOff["AANE"].CV && !this.arry_OnOff["AEWAS"].CV) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["ALOBANS"]), 1000);
                        return;
                    }
                } else {
                    this.arry_OnOff["AANE"].CV = false;
                    this.arry_OnOff["AEWAS"].CV = false;
                }

                if (this.bool_EMBANS) {
                    if (!this.arry_OnOff["MAANE"].CV && !this.arry_OnOff["MAEWAS"].CV) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["ALOBANS"]), 1000);
                        return;
                    }
                } else {
                    this.arry_OnOff["MAANE"].CV = false;
                    this.arry_OnOff["MAEWAS"].CV = false;
                }

                if (this.bool_HFLQRC) {
                    if (!this.arry_OnOff["HQRCBL"].CV && !this.arry_OnOff["HSQRCM"].CV) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["ALOQRDO"]), 1000);
                        return;
                    }
                } else {
                    this.arry_OnOff["HQRCBL"].CV = false;
                    this.arry_OnOff["HSQRCM"].CV = false;
                }


                if (this.arry_OnOff["DODDS"].CV) {
                    if (this.selectedSOTValue == "" || this.selectedSOTValue == undefined) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["SOT"]), 1000);
                        return;
                    }
                    if (this.selectedTOValue == "" || this.selectedTOValue == undefined) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["TO"]), 1000);
                        return;
                    }
                } 

                this.bool_fullLoading = true;
                this.bool_fullScreen = true;
                this.bool_CV = true;
                var isRegWPhone = this.arry_OnOff.REGWPHONE.CV;
                var isLocalized = this.arry_OnOff.ULPN.CV;
                var isEPrefix = this.arry_OnOff.UPCODE.CV;
                var checkValidLocalized = true;
                var emptyPrefix = false;
                var checkValidSocialMedia = true;

                this.arry_aac['RS'] = 2;
                this.arry_aac['SportOddsType'] = this.selectedSOTValue;
                this.arry_aac['ThemeOption'] = this.selectedTOValue;
                if (this.arry_aac.AGIT != null && this.arry_aac.AGIT.length > 0) {
                    var agi = this.arry_aac.AGIT.split("-");
                    //this.arry_aac.AGI = agi[1];
                    //this.arry_aac.AgentGroupIds = this.arry_aac
                }

                // Captcha Options
                // Set all Captcha options to false

                const captchaOptions = ["CCNO", "CCALPN", "DCC", "CCAOLN"];

                captchaOptions.forEach(option => {
                    this.arry_OnOff[option].CV = false; 
                });

                //Turn the selected radio button for Captcha to true
                if (this.str_CaptchaOption != "" && this.str_CaptchaOption != null && captchaOptions.includes(this.str_CaptchaOption)) {
                    this.arry_OnOff[this.str_CaptchaOption].CV = this.arry_OnOff[this.str_CaptchaOption].DC;
                }
                else {
                    //Default to Disabled Captcha, if no options are found
                    this.arry_OnOff["DCC"].CV = true;
                }

                if (this.arry_OnOff["FNM"].CV == false) {
                    this.arry_OnOff["FNABAN"].CV = false;
                }

                this.arry_OnOff["MD"].CV = !this.arry_OnOff["MD"].DC;
                this.arry_OnOff["AD"].CV = !this.arry_OnOff["AD"].DC;
                this.arry_OnOff["ADP"].CV = !this.arry_OnOff["ADP"].DC;
                this.arry_OnOff["HP"].CV = !this.arry_OnOff["HP"].DC;
                this.arry_OnOff["OP"].CV = !this.arry_OnOff["OP"].DC;
                this.arry_OnOff["EZP"].CV = !this.arry_OnOff["EZP"].DC;
                this.arry_OnOff["TUP"].CV = !this.arry_OnOff["TUP"].DC;
                this.arry_OnOff["CT"].CV = !this.arry_OnOff["CT"].DC;
                this.arry_OnOff["XFU"].CV = !this.arry_OnOff["XFU"].DC;
                this.arry_OnOff["STP"].CV = !this.arry_OnOff["STP"].DC;
                this.arry_OnOff["SUREP"].CV = !this.arry_OnOff["SUREP"].DC;
                this.arry_OnOff["P918"].CV = !this.arry_OnOff["P918"].DC;
                this.arry_OnOff["FUP"].CV = !this.arry_OnOff["FUP"].DC;
                this.arry_OnOff["SMP"].CV = !this.arry_OnOff["SMP"].DC;
                this.arry_OnOff["U2P"].CV = !this.arry_OnOff["U2P"].DC;
                this.arry_OnOff["LP"].CV = !this.arry_OnOff["LP"].DC;
                this.arry_OnOff["BCP"].CV = !this.arry_OnOff["BCP"].DC;
                this.arry_OnOff["FPG"].CV = !this.arry_OnOff["FPG"].DC;
                this.arry_OnOff["PGA"].CV = !this.arry_OnOff["PGA"].DC;
                this.arry_OnOff["AGP"].CV = !this.arry_OnOff["AGP"].DC;
                this.arry_OnOff["UP"].CV = !this.arry_OnOff["UP"].DC;
                this.arry_OnOff["TMONEY"].CV = !this.arry_OnOff["TMONEY"].DC;
                this.arry_OnOff["DTMB"].CV = !this.arry_OnOff["DTMB"].DC;
                this.arry_OnOff["DT"].CV = !this.arry_OnOff["DT"].DC;
                this.arry_OnOff["MB"].CV = !this.arry_OnOff["MB"].DC;
                this.arry_OnOff["FPDTMB"].CV = !this.arry_OnOff["FPDTMB"].DC;
                this.arry_OnOff["FPDT"].CV = !this.arry_OnOff["FPDT"].DC;
                this.arry_OnOff["FPMB"].CV = !this.arry_OnOff["FPMB"].DC;
                this.arry_OnOff["PP"].CV = !this.arry_OnOff["PP"].DC;
                this.arry_OnOff["DN"].CV = !this.arry_OnOff["DN"].DC;
                this.arry_OnOff["OKP"].CV = !this.arry_OnOff["OKP"].DC;
                this.arry_OnOff["MGP"].CV = !this.arry_OnOff["MGP"].DC;
                this.arry_OnOff["VIP"].CV = !this.arry_OnOff["VIP"].DC;
                this.arry_OnOff["AFP"].CV = !this.arry_OnOff["AFP"].DC;
                this.arry_OnOff["ONEP"].CV = !this.arry_OnOff["ONEP"].DC;
                this.arry_OnOff["BLEUP"].CV = !this.arry_OnOff["BLEUP"].DC;
                this.arry_OnOff["E88P"].CV = !this.arry_OnOff["E88P"].DC;
                this.arry_OnOff["PPYP"].CV = !this.arry_OnOff["PPYP"].DC;
                this.arry_OnOff["ECP"].CV = !this.arry_OnOff["ECP"].DC;
                this.arry_OnOff["ZPAY"].CV = !this.arry_OnOff["ZPAY"].DC;
                this.arry_OnOff["UPAY"].CV = !this.arry_OnOff["UPAY"].DC;
                this.arry_OnOff["DGPCNY"].CV = !this.arry_OnOff["DGPCNY"].DC;
                this.arry_OnOff["SUPER7VND"].CV = !this.arry_OnOff["SUPER7VND"].DC;                
                this.arry_OnOff["PAYNGO"].CV = !this.arry_OnOff["PAYNGO"].DC;
                this.arry_OnOff["PAYPRO"].CV = !this.arry_OnOff["PAYPRO"].DC;
                this.arry_OnOff["PAYLITE"].CV = !this.arry_OnOff["PAYLITE"].DC;
                this.arry_OnOff["HUIJUCAI"].CV = !this.arry_OnOff["HUIJUCAI"].DC;
                this.arry_OnOff["BestPay"].CV = !this.arry_OnOff["BestPay"].DC;
                this.arry_OnOff["CLOUDPAY"].CV = !this.arry_OnOff["CLOUDPAY"].DC;
                this.arry_OnOff["LNWPAY"].CV = !this.arry_OnOff["LNWPAY"].DC;

                if (this.str_PreferredDepositOption == "" && this.arry_OnOff["PDO"].CV) {
                    this.str_PreferredDepositOption = "MD";
                }
                if (!this.arry_OnOff["PDO"].CV) {
                    this.str_PreferredDepositOption = "";
                }
                if (this.str_PreferredDepositOption != "" && this.str_PreferredDepositOption != null) {
                    this.arry_OnOff[this.str_PreferredDepositOption].CV = this.arry_OnOff[this.str_PreferredDepositOption].DC;
                }

                if (this.str_TournamentNavOption == "" && this.arry_OnOff["ETBN"].CV) {
                    this.str_TournamentNavOption = "DTMB";
                }
                if (!this.arry_OnOff["ETBN"].CV) {
                    this.str_TournamentNavOption = "";
                }
                if (this.str_TournamentNavOption != "" && this.str_TournamentNavOption != null) {
                    this.arry_OnOff[this.str_TournamentNavOption].CV = this.arry_OnOff[this.str_TournamentNavOption].DC;
                }

                if (this.str_ForgotPasswordLinkOption == "" && this.arry_OnOff["EFPL"].CV) {
                    this.str_ForgotPasswordLinkOption = "FPDTMB";
                }
                if (!this.arry_OnOff["EFPL"].CV) {
                    this.str_ForgotPasswordLinkOption = "";
                }
                if (this.str_ForgotPasswordLinkOption != "" && this.str_ForgotPasswordLinkOption != null) {
                    this.arry_OnOff[this.str_ForgotPasswordLinkOption].CV = this.arry_OnOff[this.str_ForgotPasswordLinkOption].DC;
                }

                if (this.arry_OnOff["DSAB"].CV) {
                    this.arry_aac.InactiveDays = -1;
                }

                if (!this.arry_OnOff["GLIF"].CV) {
                    this.arry_OnOff["GLIFSW"].CV = false;
                }

                if (!this.arry_OnOff["EGPLL"].CV) {
                    this.arry_OnOff["DLGFML"].CV = false;
                }

                if (!isSimple) {
                    this.arry_aac.nCuzView = [];
                    for (const [key, value] of Object.entries(this.arry_OnOff)) {

                        if (value.CV == value.DC) {
                            this.arry_aac.nCuzView.push(key);
                        }
                    }
                }

                if (this.arry_OnOff["SM"].CV) {
                    if (!this.arry_OnOff["WCID"].CV && !this.arry_OnOff["LID"].CV && !this.arry_OnOff["WAID"].CV && !this.arry_OnOff["TGID"].CV && !this.arry_OnOff["ZLID"].CV) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["SMCODE"]), 1000);
                        checkValidSocialMedia = false;
                    }
                }

                this.$v.arry_aac.$touch();
                if (!this.$v.arry_aac.$error) {
                    ////if (isRegWPhone == true) {
                    //if (isLocalized == true) {
                    //    if (this.arry_aac.LocalisedList.length == 0) {
                    //        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["RPCODE"]), 1000);
                    //        checkValidLocalized = false;
                    //    } else {
                    //        if (isEPrefix == true) {
                    //            for (var i = 0; i < this.arry_aac.LocalisedList.length; i++) {
                    //                if (this.arry_aac.LocalisedList[i].PC == "") {
                    //                    emptyPrefix = true;
                    //                    break;
                    //                }
                    //            }

                    //            if (emptyPrefix) {
                    //                checkValidLocalized = false;
                    //                this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["ACO"]["EMPCODE"]), 1000);
                    //            }
                    //        }
                    //    }
                    //}
                    //else if (isRegWPhone == true) {
                    //    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["RPCODE"]), 1000);
                    //    checkValidLocalized = false;
                    //}
                    ////}

                    if (isRegWPhone == true) {
                        if (isLocalized == true) {
                            if (this.arry_cr.LocalisedList.length == 0) {
                                this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["RPCODE"]), 1000);
                                checkValidLocalized = false;
                            } else {
                                if (isEPrefix == true) {
                                    for (var i = 0; i < this.arry_cr.LocalisedList.length; i++) {
                                        if (this.arry_cr.LocalisedList[i].PC == "") {
                                            emptyPrefix = true;
                                            break;
                                        }
                                    }

                                    if (emptyPrefix) {
                                        checkValidLocalized = false;
                                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["ACO"]["EMPCODE"]), 1000);
                                    }
                                }
                            }
                        } else {
                            this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["RPCODE"]), 1000);
                            checkValidLocalized = false;
                        }
                    }

                    if (this.bool_isAgentType) {
                        this.$v.arry_cr.$touch();
                        if (!this.$v.arry_cr.$error) {
                            this.bool_showCR = false;
                        }
                    }

                    var that = this;

                    if (checkValidLocalized == true && checkValidSocialMedia == true) {
                        if (!this.arry_OnOff.RPN.CV) {
                            this.arry_OnOff.REGWPHONE.CV = false;
                            this.arry_OnOff.ULPN.CV = false;
                            this.arry_OnOff.UPCODE.CV = false;
                            this.arry_OnOff.DOTPV.CV = true;
                        }
                        this.postDataApi(`/api/acuz/s`, this.arry_aac,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                that.bool_fullScreen = false;
                                if (s) {
                                    that.bool_isAMV = false;
                                    that.bool_isAMVS = false;
                                    that.getACList();
                                    that.$root.UserInfo.getInfoApi(that);
                                }
                            });
                    } else {
                        this.bool_fullLoading = false;
                    }
                }
                else {
                    this.bool_fullLoading = false;

                    //get the object for validating.
                    const validation = this.$v["arry_aac"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            editAgentConfig(id, bool_copy = false) {
                this.showAgentConfig(1);
                this.bool_fullLoading = true;
                this.bool_CV = false;

                var that = this;
                this.getDataApi(`/api/acuz/g/${id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            
                            that.setAC(d.D);
                            that.bool_isAMV = false;

                            if (that.arry_aac.AGI != 0) {
                                that.arry_aac.AGIT = that.arry_aac.AGI;
                                that.searchAgent = ["3-" + that.arry_aac.AGI];
                            }
                            that.bool_isAMV = true;
                        }
                        if (bool_copy == true) {
                            that.searchAgent = null;
                            that.arry_aac.I = 0;
                        }
                    });

                //check customize register
                this.getDataApi(`/api/rcuz/g/${id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            if (d.D != null) {
                                that.bool_cr = true;
                                if (d.D.CuzView.length > 0) {
                                    for (var x = 0; x < d.D.CuzView.length; x++) {
                                        if (d.D.CuzView[x].CC == "RFWMP") {
                                            that.bool_cr = false;
                                        }
                                    }
                                }
                            }

                        }
                    });

            },
            viewAgentConfig(id) {
                this.bool_fullLoading = true;
                this.bool_CV = false;
                this.bool_isView = true;
                var that = this;
                this.getDataApi(`/api/acuz/g/${id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {

                            that.setAC(d.D);
                            that.bool_isAMV = false;
                            if (that.arry_aac.AGI != 0) {
                                that.arry_aac.AGIT = that.arry_aac.AGI;
                                that.searchAgent = ["3-" + that.arry_aac.AGI];
                            }
                            that.bool_isAMV = true;
                        }
                    });
            },
            selectAgentOptions(value, instanceId) {
                var temp = "";

                for (var x = 0; x < value.length; x++) {
                    if (x != 0) {
                        temp += ",";
                    }
                    var split = value[x].split("-");

                    if (split.length == 2) {
                        temp += split[1];
                    }
                    else {
                        temp += split[0];
                    }
                }
                this.arry_aac['AGIT'] = temp;

                if (temp > 0) {
                    this.getGameProviders(temp);
                } else {
                    this.dd_gameprovider = [];
                }
                //this.sensBtn = ((this.isSENS == 1 && this.arry_aac['AGIT'] != this.curAGI) ? true : false);
            },
            AFTTFG(isEnable) {
                this.arry_OnOff["HFTGBL"].CV = isEnable
                this.arry_OnOff["HFTGAL"].CV = isEnable
            },
            removeAgentConfig(data) {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            agi: data.AGI,
                            uts: data.UTS
                        };

                        this.postDataApi(`/api/acuz/d`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.getACList();
                                    that.$root.UserInfo.getInfoApi(that);
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isSort}
                this.getACList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            clearDateRangeFilter() {
                this.str_FV[1].FV = {
                    startDate: "",
                    endDate: ""
                };
            },
            removeLocaliseList(index) {
                this.$delete(this.arry_aac.LocalisedList, index);
                this.$forceUpdate();
            },
            addPrefix() {
                var exist = false;
                var isValid = true;
                var clearRequired = true;
                var isEPrefix = this.arry_OnOff.UPCODE.CV;
                var CountryCode = this.arry_aac.E_CC;
                var PrefixCode = this.arry_aac.E_PC;
                var emptyPrefix = false;

                if (CountryCode == "") {
                    clearRequired = false;
                    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["CCODE"]), 1000);
                }

                if (isEPrefix == true) {
                    if (PrefixCode == "") {
                        clearRequired = false;
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["PCODE"]), 1000);
                    } else {
                        if (this.arry_aac.LocalisedList.length > 0) {
                            for (var i = 0; i < this.arry_aac.LocalisedList.length; i++) {
                                if (this.arry_aac.LocalisedList[i].PC == "") {
                                    emptyPrefix = true;
                                    break;
                                }
                            }

                            if (emptyPrefix) {
                                clearRequired = false;
                                this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["ACO"]["EMPCODE"]), 1000);
                            }
                        }
                    }
                }

                if (clearRequired == true) {

                    var str_CC = CountryCode[0];

                    if (str_CC == "+") {
                        CountryCode = CountryCode.substr(1);
                    }

                    if (!CountryCode.match((/^[0-9]*$/))) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["ACO"]["CCODE"]), 1000);
                        isValid = false;
                    }

                    if (PrefixCode != "") {
                        if (!PrefixCode.match((/^[0-9]*$/))) {
                            this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["ACO"]["PCODE"]), 1000);
                            isValid = false;
                        }
                    }

                    if (isValid == true) {

                        for (var i = 0; i < this.arry_aac.LocalisedList.length; i++) {
                            var item = this.arry_aac.LocalisedList[i];

                            if (item.PC) {
                                if (item.PC == PrefixCode) {
                                    if (item.CC == CountryCode) {
                                        // If both PrefixCode and CountryCode match, set exist to true
                                        exist = true;
                                        break;
                                    } else {
                                        // If PrefixCode matches but CountryCode is different, set exist to false
                                        exist = false;
                                    }
                                }
                            }
                        }

                        if (exist) {
                            this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1002'), this.getLanguage["ACO"]["CPCODE"]), 1000);
                        }
                        else {

                            var w_lz = PrefixCode.substr(1);

                            this.obj_LCC = {
                                CC: CountryCode,
                                PC: PrefixCode,
                                LZ: 0,
                                PN: CountryCode + '' + w_lz
                            }
                            this.arry_aac.LocalisedList.push(this.obj_LCC);
                        }

                    }
                }
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            disableMemberSite(value) {
                this.bool_DMSA = value;
                this.arry_OnOff.DMAL.CV = value;
                this.arry_OnOff.DMAR.CV = value;
                this.arry_OnOff.DMAD.CV = value;
                this.arry_OnOff.DMAW.CV = value;
            },
            renderTitle(id) {
                if (this.bool_isView) {
                    return this.getLanguage["ACU"]["VACF"];
                }
                else {
                    return this.getLanguage["ACU"][id > 0 ? "EACF" : "AACF"];
                }

            },
            renderStyle() {
                return this.bool_isView ? "pointer-events:none" : "";
            },
            showAgentConfig(value) {
                this.agentconfig_LS = false;
                this.agentconfig_RS = false;
                this.agentconfig_MSS = false;
                this.agentconfig_BBOS = false;
                this.agentconfig_CS = false;
                switch (value) {
                    case 1:
                        this.agentconfig_LS = true;
                        break;
                    case 2:
                        this.agentconfig_RS = false; //Disable Registration Setting Tab
                        break;
                    case 3:
                        this.agentconfig_MSS = true;
                        break;
                    case 4:
                        this.agentconfig_BBOS = true;
                        break;
                    case 5:
                        this.agentconfig_CS = true;
                        break;
                }
            },
            //disableRegWithPhone(value) {
            //    this.arry_OnOff.RPN.CV = value;
            //    this.arry_OnOff.REGWPHONE.CV = value;
            //    this.arry_OnOff.ULPN.CV = !value;
            //    this.arry_OnOff.UPCODE.CV = !value;
            //    this.arry_OnOff.DOTPV.CV = !value;
            //},
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_CV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
        },
    }
</script>

<style>
    /* .col-6 {
        display: grid;
        grid-template-columns: 50px auto 50px;
    }*/

    .agentcus-grid {
        display: grid;
        grid-template-columns: 40px auto 20px
    }


    .flexcontainer {
        display: flex;
        flex-wrap: wrap;
    }

        .flexcontainer > div, .flexcontainer > label {
            flex: 100%; /* or - flex: 0 50% - or - flex-basis: 50% - */
        }

    .flex-item {
        margin-left: 50px;
    }

        .flex-item input[type="radio"], .flex-item input[type="checkbox"] {
            width: 13px;
        }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/AgentSetting/AgentCustomize.vue